webpackJsonp([28,26],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(207);
	
	var _vue = __webpack_require__(59);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _mintUi = __webpack_require__(6);
	
	var _mintUi2 = _interopRequireDefault(_mintUi);
	
	var _router = __webpack_require__(210);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _App = __webpack_require__(386);
	
	var _App2 = _interopRequireDefault(_App);
	
	__webpack_require__(363);
	
	__webpack_require__(364);
	
	__webpack_require__(330);
	
	__webpack_require__(208);
	
	__webpack_require__(166);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_mintUi2.default);
	
	new _vue2.default({
	  render: function render(f) {
	    return f(_App2.default);
	  },
	  router: _router2.default
	}).$mount('#App');
	
	_vue2.default.filter('money', function (price) {
	  var _str_price = price + '';
	  var _arr = _str_price.split('.');
	  if (_arr.length === 1) {
	    _str_price += '.00';
	  } else {
	    if (_arr[1].length === 1) {
	      _str_price += '0';
	    }
	  }
	  return _str_price;
	});
	
	_vue2.default.directive('drag', {
	  bind: function bind(el, binding) {
	    var oDiv = el;
	    oDiv.ontouchstart = function (e) {
	      var disY = e.touches[0].clientY - document.getElementById('orderDetail').offsetTop;
	      document.ontouchmove = function (e) {
	        var t = e.touches[0].clientY - disY;
	
	        binding.value({
	          top: t
	        });
	      };
	      document.ontouchend = function (e) {
	        document.ontouchstart = null;
	        document.ontouchmove = null;
	      };
	    };
	  }
	});

/***/ }),

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(16);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _typeof2 = __webpack_require__(67);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.compare = compare;
	exports.showTips = showTips;
	exports.accAdd = accAdd;
	exports.accMul = accMul;
	exports.accSub = accSub;
	exports.autoTextarea = autoTextarea;
	exports.transformDate = transformDate;
	exports.restoreDate = restoreDate;
	exports.getQueryString = getQueryString;
	exports.setupWebViewJavascriptBridge = setupWebViewJavascriptBridge;
	exports.signGenerate = signGenerate;
	exports.signGenerate2 = signGenerate2;
	exports.setDocumentTitle = setDocumentTitle;
	
	var _mintUi = __webpack_require__(6);
	
	var _blueimpMd = __webpack_require__(253);
	
	var _blueimpMd2 = _interopRequireDefault(_blueimpMd);
	
	var _jsSha = __webpack_require__(365);
	
	var _jsSha2 = _interopRequireDefault(_jsSha);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function compare(a, b) {
	  if (a === b) {
	    return 0;
	  }
	
	  var a_components = a.split('.');
	  var b_components = b.split('.');
	
	  var len = Math.min(a_components.length, b_components.length);
	
	  for (var i = 0; i < len; i++) {
	    if (parseInt(a_components[i]) > parseInt(b_components[i])) {
	      return 1;
	    }
	
	    if (parseInt(a_components[i]) < parseInt(b_components[i])) {
	      return -1;
	    }
	  }
	
	  if (a_components.length > b_components.length) {
	    return 1;
	  }
	  if (a_components.length < b_components.length) {
	    return -1;
	  }
	
	  return 0;
	}
	
	function showTips(tips) {
	  var instance = (0, _mintUi.Toast)(tips);
	  setTimeout(function () {
	    instance.close();
	  }, 2000);
	}
	
	function accAdd(arg1, arg2) {
	  var r1, r2, m, c;
	  try {
	    r1 = arg1.toString().split('.')[1].length;
	  } catch (e) {
	    r1 = 0;
	  }
	  try {
	    r2 = arg2.toString().split('.')[1].length;
	  } catch (e) {
	    r2 = 0;
	  }
	  c = Math.abs(r1 - r2);
	  m = Math.pow(10, Math.max(r1, r2));
	  if (c > 0) {
	    var cm = Math.pow(10, c);
	    if (r1 > r2) {
	      arg1 = Number(arg1.toString().replace('.', ''));
	      arg2 = Number(arg2.toString().replace('.', '')) * cm;
	    } else {
	      arg1 = Number(arg1.toString().replace('.', '')) * cm;
	      arg2 = Number(arg2.toString().replace('.', ''));
	    }
	  } else {
	    arg1 = Number(arg1.toString().replace('.', ''));
	    arg2 = Number(arg2.toString().replace('.', ''));
	  }
	  return (arg1 + arg2) / m;
	}
	
	function accMul(arg1, arg2) {
	  var m = 0;
	  var s1 = arg1.toString();
	  var s2 = arg2.toString();
	  try {
	    m += s1.split('.')[1].length;
	  } catch (e) {}
	  try {
	    m += s2.split('.')[1].length;
	  } catch (e) {}
	  return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m);
	}
	
	function accSub(arg1, arg2) {
	  var r1, r2, m, n;
	  try {
	    r1 = arg1.toString().split('.')[1].length;
	  } catch (e) {
	    r1 = 0;
	  }
	  try {
	    r2 = arg2.toString().split('.')[1].length;
	  } catch (e) {
	    r2 = 0;
	  }
	  m = Math.pow(10, Math.max(r1, r2));
	  n = r1 >= r2 ? r1 : r2;
	  return ((arg1 * m - arg2 * m) / m).toFixed(n);
	}
	
	function autoTextarea(elem, extra, maxHeight) {
	  extra = extra || 0;
	  var isFirefox = !!document.getBoxObjectFor || 'mozInnerScreenX' in window;
	  var isOpera = !!window.opera && !!window.opera.toString().indexOf('Opera');
	  var addEvent = function addEvent(type, callback) {
	    elem.addEventListener ? elem.addEventListener(type, callback, false) : elem.attachEvent('on' + type, callback);
	  };
	  var getStyle = elem.currentStyle ? function (name) {
	    var val = elem.currentStyle[name];
	    if (name === 'height' && val.search(/px/i) !== 1) {
	      var rect = elem.getBoundingClientRect();
	      return rect.bottom - rect.top - parseFloat(getStyle('paddingTop')) - parseFloat(getStyle('paddingBottom')) + 'px';
	    }
	    return val;
	  } : function (name) {
	    return window.getComputedStyle(elem, null)[name];
	  };
	  var minHeight = parseFloat(getStyle('height'));
	  elem.style.resize = 'none';
	  var change = function change() {
	    var scrollTop;
	    var height;
	    var padding = 0;
	    var style = elem.style;
	    if (elem._length === elem.value.length) return;
	    elem._length = elem.value.length;
	    if (!isFirefox && !isOpera) {
	      padding = parseInt(getStyle('paddingTop')) + parseInt(getStyle('paddingBottom'));
	    }
	    scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
	    elem.style.height = minHeight + 'px';
	    if (elem.scrollHeight > minHeight) {
	      if (maxHeight && elem.scrollHeight > maxHeight) {
	        height = maxHeight - padding;
	        style.overflowY = 'auto';
	      } else {
	        height = elem.scrollHeight - padding;
	        style.overflowY = 'hidden';
	      }
	      style.height = height + extra + 'px';
	      scrollTop += parseInt(style.height) - elem.currHeight;
	      document.body.scrollTop = scrollTop;
	      document.documentElement.scrollTop = scrollTop;
	      elem.currHeight = parseInt(style.height);
	    }
	  };
	  addEvent('propertychange', change);
	  addEvent('input', change);
	  addEvent('focus', change);
	  change();
	}
	
	var timeFormat = function timeFormat(date, fmt) {
	  var o = {
	    'M+': date.getMonth() + 1,
	    'd+': date.getDate(),
	    'h+': date.getHours(),
	    'm+': date.getMinutes(),
	    's+': date.getSeconds(),
	    'q+': Math.floor((date.getMonth() + 3) / 3),
	    'S': date.getMilliseconds() };
	  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
	  for (var k in o) {
	    if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
	  }
	  return fmt;
	};
	
	function transformDate(date) {
	  var date_obj = {
	    cn_date: date.getMonth() + 1 + '月' + date.getDate() + '日' + '周' + '日一二三四五六'.split('')[date.getDay()],
	    time: date.getHours() + ':' + date.getMinutes(),
	    week: '周' + '日一二三四五六'.split('')[date.getDay()],
	    param: timeFormat(date, 'yyyy/MM/dd hh:mm'),
	    date: timeFormat(date, 'yyyy/MM/dd')
	  };
	  return date_obj;
	}
	
	function restoreDate(date, hour, minute) {
	  var _now = new Date();
	  var _now_month = _now.getMonth() + 1;
	  var _now_year = _now.getFullYear();
	  var _date = date.slice(0, -3).split('月');
	  var _year = _date[0] >= _now_month ? _now_year : _now_year + 1;
	  var _hour = hour.slice(0, -1);
	  var _minute = minute.slice(0, -1);
	  if (_hour.length === 1) {
	    _hour = '0' + _hour;
	  }
	  if (_minute.length === 1) {
	    _minute = '0' + _minute;
	  }
	  return {
	    param: _year + '/' + _date[0] + '/' + _date[1] + ' ' + _hour + ':' + _minute,
	    date: date.slice(0, -2),
	    week: date.slice(-2),
	    time: _hour + ':' + _minute
	  };
	}
	
	function getQueryString(name) {
	  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
	  var r = window.location.search.substr(1).match(reg);
	  if (r !== null) {
	    return unescape(r[2]);
	  }
	  return null;
	}
	
	function setupWebViewJavascriptBridge(callback) {
	  if (window.WebViewJavascriptBridge) {
	    return callback(window.WebViewJavascriptBridge);
	  }
	  if (window.WVJBCallbacks) {
	    return window.WVJBCallbacks.push(callback);
	  }
	  window.WVJBCallbacks = [callback];
	  var WVJBIframe = document.createElement('iframe');
	  WVJBIframe.style.display = 'none';
	  WVJBIframe.src = 'https://__bridge_loaded__';
	  document.documentElement.appendChild(WVJBIframe);
	  setTimeout(function () {
	    document.documentElement.removeChild(WVJBIframe);
	  }, 0);
	}
	
	function signGenerate(params) {
	  var arg = [];
	  for (var i in params) {
	    if (typeof params[i] === 'undefined' || !params[i] && typeof params[i] !== 'undefined' && params[i] !== 0) {
	      params[i] = '';
	    }
	    if ((0, _typeof3.default)(params[i]) === 'object') {
	      arg.push(i + '=' + (0, _stringify2.default)(params[i]));
	    } else {
	      arg.push(i + '=' + params[i]);
	    }
	  }
	  var sign = arg.sort().join('');
	  return (0, _blueimpMd2.default)('ltb_dudubus' + sign + '5b1a212349ca1234oe3124234234f30a5');
	}
	
	function signGenerate2(params) {
	  var arg = [];
	  for (var i in params) {
	    if (typeof params[i] === 'undefined' || !params[i] && typeof params[i] !== 'undefined' && params[i] !== 0) {
	      params[i] = '';
	    }
	    if ((0, _typeof3.default)(params[i]) === 'object') {
	      arg.push(i + '=' + (0, _stringify2.default)(params[i]));
	    } else {
	      arg.push(i + '=' + params[i]);
	    }
	  }
	  var sign = arg.sort().join('');
	  var str1 = (0, _blueimpMd2.default)('ltb_dudubus' + sign + '5b1a212349ca1234oe3124234234f30a5');
	  var str2 = (0, _jsSha2.default)(str1);
	  return str1 + str2;
	}
	
	function setDocumentTitle(t) {
	  document.title = t;
	  var i = document.createElement('iframe');
	  i.style.display = 'none';
	  i.onload = function () {
	    setTimeout(function () {
	      i.remove();
	    }, 9);
	  };
	  i.src = '//m.baidu.com/favicon.ico';
	  document.body.appendChild(i);
	}

/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getOrderDetail = exports.saveInvoiceInfo = exports.getInvoiceInfo = exports.initQiYuScript = exports.clearOrder = exports.clearSelectedInfo = exports.serviceCost = exports.sendCancelOrder = exports.bindCoupon = exports.getUserCoupon = exports.setOpenCityList = exports.setOrderDetail = exports.submitOrder = exports.searchBusPriceBeforeSubmit = exports.setCachePrice = exports.setBusPrice = exports.setBusList = exports.getBusLocation = exports.setBannerList = exports.RequestCommonResponse = exports.RequestControl = undefined;
	
	var _stringify = __webpack_require__(16);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _promise = __webpack_require__(60);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _superagent = __webpack_require__(64);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _util = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RequestControl = exports.RequestControl = function RequestControl(rootState, params) {
	  if (rootState.common.enterprise_id) {
	    params.enterprise_id = rootState.common.enterprise_id;
	  }
	  if (rootState.duduApp.os === '1' || rootState.duduApp.os === '2') {
	    params.os = rootState.duduApp.os;
	    params.app_id = rootState.duduApp.app_id;
	    params.app_version = rootState.duduApp.app_version;
	    params.model = rootState.duduApp.model;
	    params.network = rootState.duduApp.network;
	    params.os_version = rootState.duduApp.os_version;
	    params.user_id = rootState.userInfo.user_id;
	    params.token = rootState.userInfo.token;
	    if (rootState.duduApp.os === '1' && (0, _util.compare)(rootState.duduApp.app_version, '5.1.5') >= 0 || rootState.duduApp.os === '2' && rootState.duduApp.app_version >= 52) {
	      params.token = encodeURIComponent(rootState.userInfo.token).replace(/%20/g, '+');
	      params.sign = (0, _util.signGenerate2)(params);
	    } else {
	      params.sign = (0, _util.signGenerate)(params);
	    }
	  }
	  return params;
	};
	
	var RequestCommonResponse = exports.RequestCommonResponse = function RequestCommonResponse(rootState, res, callback) {
	  if (res.result === '0005') {
	    rootState.common.reload_page = true;
	  } else {
	    if (callback) {
	      callback(res);
	    }
	  }
	};
	
	var setBannerList = exports.setBannerList = function setBannerList(_ref) {
	  var commit = _ref.commit,
	      state = _ref.state,
	      rootState = _ref.rootState;
	
	  var _params = {
	    city: '深圳市',
	    show_type: 2
	  };
	  _params = RequestControl(rootState, _params);
	  _superagent2.default.post('/index.php/activities/banner').send(_params).type('form').end(function (err, res) {
	    if (err) {
	      window.alert('网络异常，请稍后重试！');
	    } else {
	      res = JSON.parse(res.text);
	      if (res.result === '0000') {
	        commit('UPDATE_BANNER_LIST', res.data);
	      } else {
	        RequestCommonResponse(rootState, res);
	      }
	    }
	  });
	};
	
	var getBusLocation = exports.getBusLocation = function getBusLocation(_ref2, order_id) {
	  var commit = _ref2.commit,
	      state = _ref2.state,
	      rootState = _ref2.rootState;
	
	  var _params = {
	    order_id: order_id
	  };
	  return new _promise2.default(function (resolve, reject) {
	    _superagent2.default.post('/index.php/charter/order/bus_locations').send(_params).type('form').end(function (err, res) {
	      if (err) {
	        window.alert('网络异常，请稍后重试！');
	      } else {
	        res = JSON.parse(res.text);
	        if (res.result === '0000') {
	          resolve(res);
	        } else {
	          RequestCommonResponse(rootState, res);
	        }
	      }
	    });
	  });
	};
	
	var setBusList = exports.setBusList = function setBusList(_ref3) {
	  var commit = _ref3.commit,
	      state = _ref3.state,
	      rootState = _ref3.rootState;
	
	  var _params = {};
	  var _arr = [];
	  var _midSiteArr = [];
	  var i = 0;
	  var len;
	  commit('UPDATE_LOADING', true);
	  _params.os = state.duduApp.os ? state.duduApp.os : '0';
	  if (state.order.type === 'business') {
	    if (state.location.start_info) {
	      _params.from_city = state.location.start_info.split('-')[1];
	      _params.to_city = state.location.end_info ? state.location.end_info.split('-')[1] : '';
	      _params.from_place_lng = state.location.start_info.split('-')[2];
	      _params.from_place_lat = state.location.start_info.split('-')[3];
	      _params.from_place = state.location.start_address;
	      _params.to_place_lng = state.location.end_info.split('-')[2];
	      _params.to_place_lat = state.location.end_info.split('-')[3];
	      _params.to_place = state.location.end_address;
	      _params.start_time = state.order.start_time.param;
	      if (state.location.way_address.length > 0) {
	        _params.mid_sites = '1';
	      } else {
	        _params.mid_sites = '0';
	      }
	      switch (state.order.business_type) {
	        case 'single':
	          _params.charter_type = 0;
	          break;
	        case 'round':
	          _params.charter_type = 1;
	          _params.back_time = state.order.end_time.param;
	          break;
	        case 'day':
	          _params.charter_type = 2;
	          _params.back_time = state.order.end_time.param;
	          break;
	      }
	      for (len = state.location.way_address.length; i < len; i++) {
	        _arr.push(state.location.way_address[i].city);
	        _midSiteArr.push(state.location.way_address[i]);
	      }
	      _params.mid_cities = (0, _stringify2.default)(_arr);
	      _params.mid_sites_list = (0, _stringify2.default)(_midSiteArr);
	    }
	  } else {
	    if (state.location.szhk_start_info) {
	      _params.from_city = state.location.szhk_start_info.split('-')[1];
	      _params.to_city = state.location.szhk_end_info ? state.location.szhk_end_info.split('-')[1] : '';
	      _params.from_place_lng = state.location.szhk_start_info.split('-')[2];
	      _params.from_place_lat = state.location.szhk_start_info.split('-')[3];
	      _params.from_place = state.location.szhk_start_address;
	      _params.to_place_lng = state.location.szhk_end_info.split('-')[2];
	      _params.to_place_lat = state.location.szhk_end_info.split('-')[3];
	      _params.to_place = state.location.szhk_end_address;
	      _params.start_time = state.order.start_time.param;
	      if (state.location.way_address.length > 0) {
	        _params.mid_sites = '1';
	      } else {
	        _params.mid_sites = '0';
	      }
	      switch (state.order.szhk_type) {
	        case 'single':
	          _params.charter_type = 0;
	          break;
	        case 'round':
	          _params.charter_type = 1;
	          _params.back_time = state.order.end_time.param;
	          break;
	      }
	      for (len = state.location.szhk_way_address.length; i < len; i++) {
	        _arr.push(state.location.szhk_way_address[i].city);
	        _midSiteArr.push(state.location.szhk_way_address[i]);
	      }
	      _params.mid_cities = (0, _stringify2.default)(_arr);
	      _params.mid_sites_list = (0, _stringify2.default)(_midSiteArr);
	    }
	  }
	  return new _promise2.default(function (resolve, reject) {
	    _params = RequestControl(rootState, _params);
	    _superagent2.default.post('/index.php/charter/mine/get_auto_car_type').send(_params).type('form').end(function (err, res) {
	      commit('UPDATE_LOADING', false);
	      if (err) {
	        reject(err);
	      } else {
	        res = JSON.parse(res.text);
	        if (res.result === '0000') {
	          commit('UPDATE_BUS_LIST', res.data);
	          if (res.data.length > 0) {
	            commit('UPDATE_CURRENT_BUS', res.data[0]);
	
	            commit('UPDATE_CURRENT_BUS_INFO', {
	              total_price: res.data[0].car_price,
	              pricing_type: !!res.data[0].car_price
	            });
	            commit('UPDATE_BUS_LIST_ITEM_PRICE', {
	              id: res.data[0].car_type_id,
	              price: res.data[0].car_price
	            });
	          }
	
	          resolve(res);
	        } else {
	          RequestCommonResponse(rootState, res, reject);
	        }
	      }
	    });
	  });
	};
	
	var setBusPrice = exports.setBusPrice = function setBusPrice(_ref4) {
	  var commit = _ref4.commit,
	      state = _ref4.state,
	      rootState = _ref4.rootState;
	
	  var _charter_type;
	  var _type;
	  var _start_info = '';
	  var _end_info = '';
	  var _from_place = '';
	  var _end_place = '';
	  if (state.order.type === 'business') {
	    _type = state.order.business_type;
	    _start_info = state.location.start_info.split('-');
	    _from_place = state.location.start_address;
	    if (state.order.business_type !== 'day') {
	      _end_info = state.location.end_info.split('-');
	      _end_place = state.location.end_address;
	    }
	  } else {
	    _type = state.order.szhk_type;
	    _start_info = state.location.szhk_start_info.split('-');
	    _end_info = state.location.szhk_end_info.split('-');
	    _from_place = state.location.szhk_start_address;
	    _end_place = state.location.szhk_end_address;
	  }
	  switch (_type) {
	    case 'single':
	      _charter_type = 0;
	      break;
	    case 'round':
	      _charter_type = 1;
	      break;
	    case 'day':
	      _charter_type = 2;
	      break;
	  }
	  var _params = {
	    from_place: _from_place,
	    from_place_lng: _start_info[2],
	    from_place_lat: _start_info[3],
	    to_place: _end_place || '',
	    to_place_lng: _end_info[2] || '',
	    to_place_lat: _end_info[3] || '',
	    charter_type: _charter_type,
	    start_time: state.order.start_time.param,
	    ignore_surcharge: 1,
	    car_type_number: (0, _stringify2.default)([{
	      car_type_id: state.order.current_bus.car_type_id,
	      car_number: 1
	    }])
	  };
	  var _mid_sites = state.order.type === 'business' ? state.location.way_address : state.location.szhk_way_address;
	  var _temp_arr = [];
	  for (var j = 0, len = _mid_sites.length; j < len; j++) {
	    if (_mid_sites[j].lat) {
	      _temp_arr.push(_mid_sites[j]);
	    }
	  }
	  _params.mid_sites = (0, _stringify2.default)(_temp_arr);
	  var order_type = state.order.type === 'business' ? state.order.business_type : state.order.szhk_type;
	
	  if (order_type === 'round') {
	    _params.back_time = state.order.end_time.param;
	  }
	
	  if (order_type === 'day') {
	    _params.day_num = state.order.day || '';
	    _params.back_time = state.order.end_time.param;
	  }
	  return new _promise2.default(function (resolve, reject) {
	    commit('UPDATE_LOADING', true);
	    _params = RequestControl(rootState, _params);
	    _superagent2.default.post('/index.php/charter/mine/get_order_price_info').type('form').send(_params).end(function (err, res) {
	      commit('UPDATE_LOADING', false);
	      if (err) {
	        reject(err);
	      } else {
	        res = JSON.parse(res.text);
	        if (res.result === '0000') {
	          res.data.contain_fee = ['车辆使用费', '司机服务费', '燃油费', '发票', '路桥费'];
	          res.data.uncontain_fee = ['司机餐饮费', '司机住宿费', '停车费'];
	          commit('UPDATE_CURRENT_BUS_INFO', res.data);
	          commit('UPDATE_BUS_LIST_ITEM_PRICE', {
	            id: state.order.current_bus.car_type_id,
	            price: res.data.total_price
	          });
	          resolve(res);
	        } else {
	          RequestCommonResponse(rootState, res, reject);
	        }
	      }
	    });
	  });
	};
	
	var setCachePrice = exports.setCachePrice = function setCachePrice(_ref5, price) {
	  var commit = _ref5.commit,
	      state = _ref5.state;
	
	  commit('UPDATE_CURRENT_BUS_INFO', {
	    pricing_type: 1,
	    total_price: price
	  });
	};
	
	var searchBusPriceBeforeSubmit = exports.searchBusPriceBeforeSubmit = function searchBusPriceBeforeSubmit(_ref6, need_invoice) {
	  var commit = _ref6.commit,
	      state = _ref6.state,
	      rootState = _ref6.rootState;
	
	  var _charter_type;
	  var _type;
	  var _start_info = '';
	  var _end_info = '';
	  var _from_place = '';
	  var _end_place = '';
	  if (state.order.type === 'business') {
	    _type = state.order.business_type;
	    _start_info = state.location.start_info.split('-');
	    _from_place = state.location.start_address;
	    if (state.order.business_type !== 'day') {
	      _end_info = state.location.end_info.split('-');
	      _end_place = state.location.end_address;
	    }
	  } else {
	    _type = state.order.szhk_type;
	    _start_info = state.location.szhk_start_info.split('-');
	    _end_info = state.location.szhk_end_info.split('-');
	    _from_place = state.location.szhk_start_address;
	    _end_place = state.location.szhk_end_address;
	  }
	  switch (_type) {
	    case 'single':
	      _charter_type = 0;
	      break;
	    case 'round':
	      _charter_type = 1;
	      break;
	    case 'day':
	      _charter_type = 2;
	      break;
	  }
	  var _selected_bus = [];
	  for (var i = 0, len = state.order.bus_bill.length; i < len; i++) {
	    var _item = state.order.bus_bill[i];
	    _selected_bus[i] = {
	      car_type_id: _item.car_type_id,
	      car_number: _item.bus_num
	    };
	    if (_item.price) {
	      _selected_bus[i].car_fee = _item.price;
	    }
	  }
	  var _params = {
	    from_place: _from_place,
	    from_place_lng: _start_info[2],
	    from_place_lat: _start_info[3],
	    charter_type: _charter_type,
	    start_time: state.order.start_time.param,
	    ignore_surcharge: 1,
	    car_type_number: (0, _stringify2.default)(_selected_bus)
	  };
	  var _mid_sites = state.order.type === 'business' ? state.location.way_address : state.location.szhk_way_address;
	  var _temp_arr = [];
	  for (var j = 0, _len = _mid_sites.length; j < _len; j++) {
	    if (_mid_sites[j].lat) {
	      _temp_arr.push(_mid_sites[j]);
	    }
	  }
	  _params.mid_sites = (0, _stringify2.default)(_temp_arr);
	  if (_charter_type !== 2) {
	    _params.to_place = _end_place;
	    _params.to_place_lng = _end_info[2];
	    _params.to_place_lat = _end_info[3];
	  }
	  var order_type = state.order.type === 'business' ? state.order.business_type : state.order.szhk_type;
	
	  if (order_type === 'round') {
	    _params.back_time = state.order.end_time.param;
	  }
	  if (order_type === 'day') {
	    _params.day_num = state.order.day;
	    _params.back_time = state.order.end_time.param;
	  }
	  if (need_invoice) {
	    _params.added_rule = '0003';
	  }
	  return new _promise2.default(function (resolve, reject) {
	    _params = RequestControl(rootState, _params);
	    _superagent2.default.post('/index.php/charter/mine/get_order_price_info').type('form').send(_params).end(function (err, res) {
	      if (err) {
	        reject(err);
	      } else {
	        res = JSON.parse(res.text);
	        if (res.result === '0000') {
	          resolve(res);
	        } else {
	          RequestCommonResponse(rootState, res, reject);
	        }
	      }
	    });
	  });
	};
	
	var submitOrder = exports.submitOrder = function submitOrder(_ref7, params) {
	  var commit = _ref7.commit,
	      state = _ref7.state,
	      rootState = _ref7.rootState;
	
	  var _charter_type;
	  var _type;
	  var _start_info = '';
	  var _end_info = '';
	  var _from_place = '';
	  var _end_place = '';
	  if (state.order.type === 'business') {
	    _type = state.order.business_type;
	    _start_info = state.location.start_info.split('-');
	    _from_place = state.location.start_address;
	    _end_info = state.location.end_info.split('-');
	    _end_place = state.location.end_address;
	  } else {
	    _type = state.order.szhk_type;
	    _start_info = state.location.szhk_start_info.split('-');
	    _end_info = state.location.szhk_end_info.split('-');
	    _from_place = state.location.szhk_start_address;
	    _end_place = state.location.szhk_end_address;
	  }
	  switch (_type) {
	    case 'single':
	      _charter_type = 0;
	      break;
	    case 'round':
	      _charter_type = 1;
	      break;
	    case 'day':
	      _charter_type = 2;
	      break;
	  }
	  var _selected_bus = [];
	  for (var i = 0, len = state.order.bus_bill.length; i < len; i++) {
	    var _item = state.order.bus_bill[i];
	    _selected_bus[i] = {
	      car_type_id: _item.car_type_id,
	      car_number: _item.bus_num
	    };
	    if (_item.price) {
	      _selected_bus[i].car_fee = _item.price;
	    }
	  }
	  var _params = {
	    from_place: _from_place,
	    from_province: _start_info[0],
	    from_city: _start_info[1],
	    from_place_lng: _start_info[2],
	    from_place_lat: _start_info[3],
	    form_area: '',
	    is_need_invoice: params.is_need_invoice,
	    charter_type: _charter_type,
	    order_km: state.location.line_distance.distance.text.replace('公里', ''),
	    start_time: state.order.start_time.param,
	    ignore_surcharge: 1,
	    car_type_number: (0, _stringify2.default)(_selected_bus),
	    contact_name: params.contact_name,
	    contact_phone: params.contact_phone,
	    use_user: params.use_user,
	    use_user_phone: params.use_user_phone,
	    user_remark: params.user_remark,
	    sub_type: params.sub_type,
	    os: state.duduApp.os ? state.duduApp.os : '0',
	    to_place: _end_place,
	    to_province: _end_info[0],
	    to_city: _end_info[1],
	    to_place_lng: _end_info[2],
	    to_place_lat: _end_info[3],
	    to_area: ''
	  };
	  if (params.invoice_type) {
	    _params.invoice_type = params.invoice_type;
	  }
	  var _mid_sites = state.order.type === 'business' ? state.location.way_address : state.location.szhk_way_address;
	  var _temp_arr = [];
	  for (var j = 0, _len = _mid_sites.length; j < _len; j++) {
	    if (_mid_sites[j].lat) {
	      _temp_arr.push(_mid_sites[j]);
	    }
	  }
	  _params.mid_sites = (0, _stringify2.default)(_temp_arr);
	  if (params.price) {
	    _params.price = params.price;
	  }
	  if (params.invoice_title) {
	    _params.added_rule = '0003';
	    _params.invoice_title = params.invoice_title;
	    _params.invoice_address = params.invoice_address;
	    _params.invoice_contact_name = params.invoice_contact_name;
	    _params.invoice_contact_phone = params.invoice_contact_phone;
	  }
	  if (_charter_type === 2 || _charter_type === 1) {
	    _params.back_time = state.order.end_time.param;
	  }
	  return new _promise2.default(function (resolve, reject) {
	    _params = RequestControl(rootState, _params);
	    _superagent2.default.post('/index.php/charter/mine/create_order').type('form').send(_params).end(function (err, res) {
	      if (err) {
	        reject(err);
	      } else {
	        res = JSON.parse(res.text);
	        if (res.result === '0000') {
	          resolve(res);
	        } else {
	          RequestCommonResponse(rootState, res, reject);
	        }
	      }
	    });
	  });
	};
	
	var setOrderDetail = exports.setOrderDetail = function setOrderDetail(_ref8, params) {
	  var commit = _ref8.commit,
	      state = _ref8.state,
	      rootState = _ref8.rootState;
	
	  params.user_id = state.userInfo.user_id;
	
	  return new _promise2.default(function (resolve, reject) {
	    params = RequestControl(rootState, params);
	    _superagent2.default.post('/index.php/order/mine/get_charter_details').type('form').send(params).end(function (err, res) {
	      if (err) {
	        reject(err);
	      } else {
	        res = JSON.parse(res.text);
	        if (res.result === '0000') {
	          resolve(res);
	        } else {
	          RequestCommonResponse(rootState, res, reject);
	        }
	      }
	    });
	  });
	};
	
	var setOpenCityList = exports.setOpenCityList = function setOpenCityList(_ref9, isFormat) {
	  var commit = _ref9.commit,
	      state = _ref9.state,
	      rootState = _ref9.rootState;
	
	  var _params = {
	    format: isFormat || 0 };
	  return new _promise2.default(function (resolve, reject) {
	    _params = RequestControl(rootState, _params);
	    _superagent2.default.post('/index.php/charter/mine/get_service_city').type('form').send(_params).end(function (err, res) {
	      if (err) throw err;
	      var data = JSON.parse(res.text).data;
	      if (!isFormat) {
	        commit('UPDATE_OPEN_CITY_LIST', data);
	      } else {
	        commit('UPDATE_OPEN_CITY_LIST_FORMAT', data);
	      }
	    });
	  });
	};
	
	var getUserCoupon = exports.getUserCoupon = function getUserCoupon(_ref10, price) {
	  var commit = _ref10.commit,
	      state = _ref10.state,
	      rootState = _ref10.rootState;
	
	  var _params = {
	    user_id: state.userInfo.user_id,
	    type: '8',
	    pay_price: price || state.order.recent_price
	  };
	  if (state.duduApp.os) {
	    _params.os = state.duduApp.os;
	  }
	  return new _promise2.default(function (resolve, reject) {
	    _params = RequestControl(rootState, _params);
	    _superagent2.default.post('/index.php/users/vouchers/get_able_vouchers').send(_params).type('form').end(function (err, res) {
	      if (err) throw err;
	      var _res = JSON.parse(res.text);
	      if (_res.result === '0000') {
	        resolve(_res);
	      } else {
	        RequestCommonResponse(rootState, res, reject);
	      }
	    });
	  });
	};
	
	var bindCoupon = exports.bindCoupon = function bindCoupon(_ref11, params) {
	  var commit = _ref11.commit,
	      state = _ref11.state,
	      rootState = _ref11.rootState;
	
	  var _params = {
	    user_id: state.userInfo.user_id,
	    order_id: params.order_id,
	    use_voucher_type: 2,
	    voucher_code: params.coupon_id
	  };
	  return new _promise2.default(function (resolve, reject) {
	    _params = RequestControl(rootState, _params);
	    _superagent2.default.post('/index.php/charter/mine/check_pay_order').type('form').send(_params).end(function (err, res) {
	      if (err) {
	        reject(err);
	      } else {
	        res = JSON.parse(res.text);
	        if (res.result === '0000') {
	          resolve(res);
	        } else {
	          RequestCommonResponse(rootState, res, reject);
	        }
	      }
	    });
	  });
	};
	
	var sendCancelOrder = exports.sendCancelOrder = function sendCancelOrder(_ref12, order_id) {
	  var commit = _ref12.commit,
	      state = _ref12.state,
	      rootState = _ref12.rootState;
	
	  var _params = {
	    user_id: state.userInfo.user_id,
	    order_id: order_id
	  };
	  return new _promise2.default(function (resolve, reject) {
	    _params = RequestControl(rootState, _params);
	    commit('UPDATE_LOADING', true);
	    _superagent2.default.post('/index.php/charter/mine/cancel_orde').type('form').send(_params).end(function (err, res) {
	      commit('UPDATE_LOADING', false);
	      if (err) {} else {
	        res = JSON.parse(res.text);
	        if (res.result === '0000') {
	          resolve(res);
	        } else {
	          RequestCommonResponse(rootState, res, reject);
	        }
	      }
	    });
	  });
	};
	
	var serviceCost = exports.serviceCost = function serviceCost(_ref13, params) {
	  var commit = _ref13.commit,
	      state = _ref13.state,
	      rootState = _ref13.rootState;
	
	  var _params = {
	    user_id: state.userInfo.user_id,
	    order_id: params.order_id,
	    city_name: params.city_name
	  };
	  return new _promise2.default(function (resolve, reject) {
	    _params = RequestControl(rootState, _params);
	    _superagent2.default.post('/index.php/charter/mine/new_cancel_order').type('form').send(_params).end(function (err, res) {
	      if (err) {
	        reject(err);
	      } else {
	        res = JSON.parse(res.text);
	        if (res.result === '0000') {
	          resolve(res);
	        } else {
	          RequestCommonResponse(rootState, res, reject);
	        }
	      }
	    });
	  });
	};
	var clearSelectedInfo = exports.clearSelectedInfo = function clearSelectedInfo(_ref14) {
	  var commit = _ref14.commit;
	
	  commit('RESET_SELECTED_BUS');
	  commit('UPDATE_SELECT_COUPON', {
	    vouchers_Identifier: null,
	    vouchers_money: null
	  });
	};
	
	var clearOrder = exports.clearOrder = function clearOrder(_ref15) {
	  var commit = _ref15.commit;
	
	  commit('UPDATE_START_TIME', '');
	  commit('UPDATE_END_TIME', '');
	  commit('UPDATE_START_ADDRESS', '');
	  commit('UPDATE_START_INFO', '');
	  commit('UPDATE_END_ADDRESS', '');
	  commit('UPDATE_END_INFO', '');
	  commit('UPDATE_SZHK_START_ADDRESS', '');
	  commit('UPDATE_SZHK_START_INFO', '');
	  commit('UPDATE_SZHK_END_ADDRESS', '');
	  commit('UPDATE_SZHK_END_INFO', '');
	  commit('UPDATE_WAY_ADDRESS', {});
	  commit('UPDATE_WAY_INFO', '');
	  commit('UPDATE_SZHK_WAY_ADDRESS', {});
	  commit('UPDATE_SZHK_WAY_INFO', '');
	  commit('RESET_SELECTED_BUS');
	  commit('UPDATE_SELECT_COUPON', {
	    vouchers_Identifier: null,
	    vouchers_money: null
	  });
	  commit('UPDATE_ORDER_TYPE', 'business');
	  commit('UPDATE_BUSINESS_TYPE', 'round');
	  commit('UPDATE_SZHK_TYPE', 'round');
	  commit('UPDATE_ORDER_RANGE', '');
	  commit('UPDATE_ORDER_DAY', '');
	};
	
	var initQiYuScript = exports.initQiYuScript = function initQiYuScript(_ref16) {
	  var commit = _ref16.commit;
	
	  if (!(window.ysf && window.ysf.ROOT)) {
	    var _script = document.createElement('script');
	    _script.src = 'https://qiyukf.com/script/64ac1e6257cc02795de5a16228ed6a9a.js';
	    document.body.appendChild(_script);
	  }
	};
	
	var getInvoiceInfo = exports.getInvoiceInfo = function getInvoiceInfo(_ref17) {
	  var commit = _ref17.commit,
	      state = _ref17.state,
	      rootState = _ref17.rootState;
	
	  var _params = {};
	  return new _promise2.default(function (resolve, reject) {
	    _params = RequestControl(rootState, _params);
	    _superagent2.default.post('/index.php/charter/mine/get_invoice_info').type('form').send(_params).end(function (err, res) {
	      if (err) {
	        reject(err);
	      } else {
	        res = JSON.parse(res.text);
	        if (res.result === '0000') {
	          resolve(res);
	        } else {
	          RequestCommonResponse(rootState, res, reject);
	        }
	      }
	    });
	  });
	};
	
	var saveInvoiceInfo = exports.saveInvoiceInfo = function saveInvoiceInfo(_ref18, params) {
	  var commit = _ref18.commit,
	      state = _ref18.state,
	      rootState = _ref18.rootState;
	
	  return new _promise2.default(function (resolve, reject) {
	    var _params = RequestControl(rootState, params);
	    _superagent2.default.post('/index.php/charter/mine/save_invoice_info').type('form').send(_params).end(function (err, res) {
	      if (err) {
	        reject(err);
	      } else {
	        res = JSON.parse(res.text);
	        if (res.result === '0000') {
	          resolve(res);
	        } else {
	          RequestCommonResponse(rootState, res, reject);
	        }
	      }
	    });
	  });
	};
	
	var getOrderDetail = exports.getOrderDetail = function getOrderDetail(_ref19, order_id) {
	  var commit = _ref19.commit,
	      state = _ref19.state,
	      rootState = _ref19.rootState;
	
	  var _params = {
	    order_id: order_id
	  };
	  _params = RequestControl(rootState, _params);
	  _superagent2.default.post('/index.php/order/mine/get_charter_details').send(_params).type('form').end(function (err, res) {
	    if (err) {
	      window.alert('网络异常，请稍后重试！');
	    } else {
	      res = JSON.parse(res.text);
	      if (res.result === '0000') {
	        if (parseInt(res.data.sub_type) === 0) {
	          commit('UPDATE_ORDER_TYPE', 'business');
	        } else if (parseInt(res.data.sub_type) === 1) {
	          commit('UPDATE_ORDER_TYPE', 'szhk');
	        }
	        if (parseInt(res.data.charter_type) === 0) {
	          commit('UPDATE_BUSINESS_TYPE', 'single');
	          commit('UPDATE_SZHK_TYPE', 'single');
	        } else if (parseInt(res.data.charter_type) === 1) {
	          commit('UPDATE_BUSINESS_TYPE', 'round');
	          commit('UPDATE_SZHK_TYPE', 'round');
	        } else if (parseInt(res.data.charter_type) === 2) {
	          commit('UPDATE_BUSINESS_TYPE', 'day');
	        }
	        var start_info = { 'province': res.data.from_province, 'city': res.data.from_city, 'lng': res.data.from_place_lng, 'lat': res.data.from_place_lat };
	        var end_info = { 'province': res.data.to_province, 'city': res.data.to_city, 'lng': res.data.to_place_lng, 'lat': res.data.to_place_lat };
	        var way_address = [];
	        if (res.data.mid_sites.length > 0) {
	          for (var i = 0, len = res.data.mid_sites.length; i < len; i++) {
	            if (res.data.mid_sites[i].address) {
	              way_address.push(res.data.mid_sites[i]);
	            }
	          }
	        }
	        commit('UPDATE_START_TIME', '');
	        commit('UPDATE_END_TIME', '');
	        if (parseInt(res.data.sub_type) === 0) {
	          commit('UPDATE_START_ADDRESS', res.data.from_place);
	          commit('UPDATE_START_INFO', start_info);
	          commit('UPDATE_END_ADDRESS', res.data.to_place);
	          commit('UPDATE_END_INFO', end_info);
	          commit('UPDATE_WAY_INFO', res.data.mid_sites);
	          window.localStorage.setItem('way_address', (0, _stringify2.default)(way_address));
	        } else if (parseInt(res.data.sub_type) === 1) {
	          commit('UPDATE_SZHK_START_ADDRESS', res.data.from_place);
	          commit('UPDATE_SZHK_START_INFO', start_info);
	          commit('UPDATE_SZHK_END_ADDRESS', res.data.to_place);
	          commit('UPDATE_SZHK_END_INFO', end_info);
	          commit('UPDATE_SZHK_WAY_INFO', res.data.mid_sites);
	          window.localStorage.setItem('szhk_way_address', (0, _stringify2.default)(way_address));
	        }
	        window.localStorage.setItem('bus_selected_list', (0, _stringify2.default)(res.data.car_type_info));
	        var user_message = { 'invoice_need': res.data.invoice_need, 'is_use_user': res.data.is_use_user, 'contact_name': res.data.contact_name, 'contact_phone': res.data.contact_phone, 'use_user': res.data.use_user, 'use_user_phone': res.data.use_user_phone, 'user_remark': res.data.user_remark };
	        window.localStorage.setItem('user_message', (0, _stringify2.default)(user_message));
	      } else {
	        RequestCommonResponse(rootState, res);
	      }
	    }
	  });
	};

/***/ }),

/***/ 85:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var UPDATE_LOADING = exports.UPDATE_LOADING = 'UPDATE_LOADING';
	var UPDATE_DIRECTION = exports.UPDATE_DIRECTION = 'UPDATE_DIRECTION';
	var UPDATE_BACK_PATH = exports.UPDATE_BACK_PATH = 'UPDATE_BACK_PATH';
	var UPDATE_PAGE_FROM = exports.UPDATE_PAGE_FROM = 'UPDATE_PAGE_FROM';
	var UPDATE_BANNER_LIST = exports.UPDATE_BANNER_LIST = 'UPDATE_BANNER_LIST';
	var SET_OS = exports.SET_OS = 'SET_OS';
	var SET_APP_PARAMS = exports.SET_APP_PARAMS = 'SET_APP_PARAMS';
	var UPDATE_INNERHEIGHT = exports.UPDATE_INNERHEIGHT = 'UPDATE_INNERHEIGHT';
	
	var UPDATE_BUS_LIST = exports.UPDATE_BUS_LIST = 'UPDATE_BUS_LIST';
	var UPDATE_CURRENT_BUS = exports.UPDATE_CURRENT_BUS = 'UPDATE_CURRENT_BUS';
	var UPDATE_CURRENT_BUS_INFO = exports.UPDATE_CURRENT_BUS_INFO = 'UPDATE_CURRENT_BUS_INFO';
	var UPDATE_ORDER_TYPE = exports.UPDATE_ORDER_TYPE = 'UPDATE_ORDER_TYPE';
	var UPDATE_BUSINESS_TYPE = exports.UPDATE_BUSINESS_TYPE = 'UPDATE_BUSINESS_TYPE';
	var UPDATE_SZHK_TYPE = exports.UPDATE_SZHK_TYPE = 'UPDATE_SZHK_TYPE';
	var UPDATE_START_TIME = exports.UPDATE_START_TIME = 'UPDATE_START_TIME';
	var UPDATE_END_TIME = exports.UPDATE_END_TIME = 'UPDATE_END_TIME';
	var UPDATE_ORDER_DAY = exports.UPDATE_ORDER_DAY = 'UPDATE_ORDER_DAY';
	var UPDATE_ORDER_RANGE = exports.UPDATE_ORDER_RANGE = 'UPDATE_ORDER_RANGE';
	var UPDATE_BUS_BILL = exports.UPDATE_BUS_BILL = 'UPDATE_BUS_BILL';
	
	var UPDATE_BUS_LIST_ITEM_PRICE = exports.UPDATE_BUS_LIST_ITEM_PRICE = 'UPDATE_BUS_LIST_ITEM_PRICE';
	var UPDATE_CURRENT_CITY = exports.UPDATE_CURRENT_CITY = 'UPDATE_CURRENT_CITY';
	
	var UPDATE_BUS_BILL_NUM = exports.UPDATE_BUS_BILL_NUM = 'UPDATE_BUS_BILL_NUM';
	var UPDATE_INVOICE_INFO = exports.UPDATE_INVOICE_INFO = 'UPDATE_INVOICE_INFO';
	
	var UPDATE_START_INFO = exports.UPDATE_START_INFO = 'UPDATE_START_INFO';
	var UPDATE_START_ADDRESS = exports.UPDATE_START_ADDRESS = 'UPDATE_START_ADDRESS';
	
	var UPDATE_END_INFO = exports.UPDATE_END_INFO = 'UPDATE_END_INFO';
	var UPDATE_END_ADDRESS = exports.UPDATE_END_ADDRESS = 'UPDATE_END_ADDRESS';
	
	var UPDATE_WAY_INFO = exports.UPDATE_WAY_INFO = 'UPDATE_WAY_INFO';
	var UPDATE_WAY_ADDRESS = exports.UPDATE_WAY_ADDRESS = 'UPDATE_WAY_ADDRESS';
	
	var UPDATE_SZHK_START_INFO = exports.UPDATE_SZHK_START_INFO = 'UPDATE_SZHK_START_INFO';
	var UPDATE_SZHK_START_ADDRESS = exports.UPDATE_SZHK_START_ADDRESS = 'UPDATE_SZHK_START_ADDRESS';
	var UPDATE_SZHK_END_INFO = exports.UPDATE_SZHK_END_INFO = 'UPDATE_SZHK_END_INFO';
	var UPDATE_SZHK_END_ADDRESS = exports.UPDATE_SZHK_END_ADDRESS = 'UPDATE_SZHK_END_ADDRESS';
	var UPDATE_SZHK_WAY_INFO = exports.UPDATE_SZHK_WAY_INFO = 'UPDATE_SZHK_WAY_INFO';
	var UPDATE_SZHK_WAY_ADDRESS = exports.UPDATE_SZHK_WAY_ADDRESS = 'UPDATE_SZHK_WAY_ADDRESS';
	var UPDATE_HK_START = exports.UPDATE_HK_START = 'UPDATE_HK_START';
	var UPDATE_HISTORY_ADDRESS = exports.UPDATE_HISTORY_ADDRESS = 'UPDATE_HISTORY_ADDRESS';
	
	var UPDATE_USER_ID = exports.UPDATE_USER_ID = 'UPDATE_USER_ID';
	var UPDATE_USER_PHONE = exports.UPDATE_USER_PHONE = 'UPDATE_USER_PHONE';
	var UPDATE_USER_HEAD = exports.UPDATE_USER_HEAD = 'UPDATE_USER_HEAD';
	var SET_USER_TOKEN = exports.SET_USER_TOKEN = 'SET_USER_TOKEN';
	
	var UPDATE_SELECT_COUPON = exports.UPDATE_SELECT_COUPON = 'UPDATE_SELECT_COUPON';
	var UPDATE_RECENT_PRICE = exports.UPDATE_RECENT_PRICE = 'UPDATE_RECENT_PRICE';
	var UPDATE_TOTAL_PRICE = exports.UPDATE_TOTAL_PRICE = 'UPDATE_TOTAL_PRICE';
	var RESET_SELECTED_BUS = exports.RESET_SELECTED_BUS = 'RESET_SELECTED_BUS';
	var UPDATE_OPEN_CITY = exports.UPDATE_OPEN_CITY = 'UPDATE_OPEN_CITY';
	var UPDATE_OPEN_CITY_ERROR = exports.UPDATE_OPEN_CITY_ERROR = 'UPDATE_OPEN_CITY_ERROR';
	var UPDATE_OPEN_CITY_LIST = exports.UPDATE_OPEN_CITY_LIST = 'UPDATE_OPEN_CITY_LIST';
	var UPDATE_OPEN_CITY_LIST_FORMAT = exports.UPDATE_OPEN_CITY_LIST_FORMAT = 'UPDATE_OPEN_CITY_LIST_FORMAT';
	var UPDATE_LINE_DISTANCE = exports.UPDATE_LINE_DISTANCE = 'UPDATE_LINE_DISTANCE';
	var JUMP_LOGIN = exports.JUMP_LOGIN = 'JUMP_LOGIN';
	var UPDATE_IS_USED_LISTBUTTON = exports.UPDATE_IS_USED_LISTBUTTON = 'UPDATE_IS_USED_LISTBUTTON';
	
	var UPDATE_TIPS_ADD_SITE = exports.UPDATE_TIPS_ADD_SITE = 'UPDATE_TIPS_ADD_SITE';
	
	var UPDATE_SELECT_OPEN_CITY = exports.UPDATE_SELECT_OPEN_CITY = 'UPDATE_SELECT_OPEN_CITY';
	
	var UPDATE_ENTERPRISE_ID = exports.UPDATE_ENTERPRISE_ID = 'UPDATE_ENTERPRISE_ID';

/***/ }),

/***/ 113:
/***/ (function(module, exports) {

	module.exports = window.BMap;

/***/ }),

/***/ 166:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (data) {
	    var share_title = '要包车，找嘟嘟';
	    var share_desc = '提供专业标准化的互联网包车服务';
	    var share_timeline_desc = '嘟嘟包车-互联网包车神器';
	    var share_url = window.location.origin + '/index.php/users/weixin/wx_login';
	    var share_img = window.location.origin + '/baoche_frontend/src/assets/img/dudu.png';
	    wx.config({
	        debug: false,
	        appId: data.appId,
	        timestamp: data.timestamp,
	        nonceStr: data.nonceStr,
	        signature: data.signature,
	        jsApiList: ["onMenuShareAppMessage", "onMenuShareTimeline", "onMenuShareQQ", "onMenuShareWeibo", "onMenuShareQZone"] });
	
	    wx.ready(function () {
	        wx.onMenuShareTimeline({
	            title: share_timeline_desc,
	            link: share_url,
	            imgUrl: share_img,
	            success: function success() {},
	            cancel: function cancel() {}
	        });
	        wx.onMenuShareAppMessage({
	            title: share_title,
	            desc: share_desc,
	            link: share_url,
	            imgUrl: share_img,
	            success: function success() {},
	            cancel: function cancel() {}
	        });
	        wx.onMenuShareQZone({
	            title: share_title,
	            link: share_url,
	            imgUrl: share_img,
	            success: function success() {},
	            cancel: function cancel() {}
	        });
	        wx.onMenuShareQQ({
	            title: share_title,
	            link: share_url,
	            imgUrl: share_img,
	            success: function success() {},
	            cancel: function cancel() {}
	        });
	        wx.onMenuShareWeibo({
	            title: share_title,
	            link: share_url,
	            imgUrl: share_img,
	            success: function success() {},
	            cancel: function cancel() {}
	        });
	    });
	
	    wx.error(function (res) {});
	};

/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(59);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(3);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _actions = __webpack_require__(84);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _getters = __webpack_require__(211);
	
	var getters = _interopRequireWildcard(_getters);
	
	var _common = __webpack_require__(212);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _location = __webpack_require__(214);
	
	var _location2 = _interopRequireDefault(_location);
	
	var _order = __webpack_require__(168);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _userInfo = __webpack_require__(169);
	
	var _userInfo2 = _interopRequireDefault(_userInfo);
	
	var _myOrder = __webpack_require__(216);
	
	var _myOrder2 = _interopRequireDefault(_myOrder);
	
	var _myCoupon = __webpack_require__(215);
	
	var _myCoupon2 = _interopRequireDefault(_myCoupon);
	
	var _rater = __webpack_require__(218);
	
	var _rater2 = _interopRequireDefault(_rater);
	
	var _pay = __webpack_require__(217);
	
	var _pay2 = _interopRequireDefault(_pay);
	
	var _duduApp = __webpack_require__(213);
	
	var _duduApp2 = _interopRequireDefault(_duduApp);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	exports.default = new _vuex2.default.Store({
	  actions: actions,
	  getters: getters,
	  modules: {
	    common: _common2.default,
	    location: _location2.default,
	    order: _order2.default,
	    userInfo: _userInfo2.default,
	    myOrder: _myOrder2.default,
	    myCoupon: _myCoupon2.default,
	    rater: _rater2.default,
	    pay: _pay2.default,
	    duduApp: _duduApp2.default
	  }
	});

/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(60);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _defineProperty2 = __webpack_require__(86);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _stringify = __webpack_require__(16);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _mutations;
	
	var _mutationTypes = __webpack_require__(85);
	
	var _superagent = __webpack_require__(64);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _actions = __webpack_require__(84);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  type: window.localStorage.getItem('order_type') || 'business',
	  business_type: window.localStorage.getItem('business_type') || 'round',
	  szhk_type: window.localStorage.getItem('szhk_type') || 'round',
	  start_time: window.localStorage.getItem('start_time') ? JSON.parse(window.localStorage.getItem('start_time')) : null,
	  end_time: window.localStorage.getItem('end_time') ? JSON.parse(window.localStorage.getItem('end_time')) : null,
	  day: window.localStorage.getItem('day') || '',
	  range: window.localStorage.getItem('range'),
	  bus_list: [],
	  current_bus: window.localStorage.getItem('current_bus') ? JSON.parse(window.localStorage.getItem('current_bus')) : {},
	  current_bus_info: window.localStorage.getItem('current_bus') ? JSON.parse(window.localStorage.getItem('current_bus_info')) : {},
	  bus_bill: [],
	  open_city_list: [],
	  open_city_list_format: [],
	  recent_price: window.localStorage.getItem('recent_price') || null,
	  total_price: window.localStorage.getItem('total_price') || null,
	  fee_config: {
	    '0001': '司机餐饮费',
	    '0002': '司机住宿费',
	    '0003': '发票',
	    '0004': '路桥费',
	    '0005': '车辆使用费',
	    '0006': '燃油费',
	    '0007': '司机服务费',
	    '0008': '停车费'
	  }
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_ORDER_TYPE, function (state, type) {
	  state.type = type;
	  window.localStorage.setItem('order_type', type);
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_CURRENT_BUS, function (state, data) {
	  state.current_bus = data;
	  window.localStorage.setItem('current_bus', (0, _stringify2.default)(data));
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_BUS_LIST, function (state, data) {
	  state.bus_list = data;
	  window.localStorage.setItem('bus_list', (0, _stringify2.default)(data));
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_BUS_LIST_ITEM_PRICE, function (state, _ref) {
	  var id = _ref.id,
	      price = _ref.price;
	
	  for (var i = 0, len = state.bus_list.length; i < len; i++) {
	    if (state.bus_list[i].car_type_id === id) {
	      state.bus_list[i].price = price;
	      break;
	    }
	  }
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_CURRENT_BUS_INFO, function (state, data) {
	  data = data || {};
	  data.contain_fee = ['车辆使用费', '司机服务费', '燃油费', '发票', '路桥费'];
	  data.uncontain_fee = ['司机餐饮费', '司机住宿费', '停车费'];
	  state.current_bus_info = data;
	  window.localStorage.setItem('current_bus_info', (0, _stringify2.default)(data));
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_BUSINESS_TYPE, function (state, type) {
	  state.business_type = type;
	  window.localStorage.setItem('business_type', type);
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_SZHK_TYPE, function (state, type) {
	  state.szhk_type = type;
	  window.localStorage.setItem('szhk_type', type);
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_START_TIME, function (state, time) {
	  state.start_time = time;
	  window.localStorage.setItem('start_time', (0, _stringify2.default)(time));
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_END_TIME, function (state, time) {
	  state.end_time = time;
	  window.localStorage.setItem('end_time', (0, _stringify2.default)(time));
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_ORDER_DAY, function (state, day_num) {
	  state.day = day_num;
	  window.localStorage.setItem('day', day_num);
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_ORDER_RANGE, function (state, range) {
	  state.range = range;
	  window.localStorage.setItem('range', range);
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_BUS_BILL_NUM, function (state, _ref2) {
	  var index = _ref2.index,
	      type = _ref2.type;
	
	  if (type === 'add') {
	    if (state.bus_bill[index].bus_num < 9) {
	      state.bus_bill[index].bus_num++;
	    }
	  } else {
	    if (state.bus_bill[index].bus_num > 1) {
	      state.bus_bill[index].bus_num--;
	    } else {
	      state.bus_bill.splice(index, 1);
	    }
	  }
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_BUS_BILL, function (state, bus) {
	  state.bus_bill.push(bus);
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_OPEN_CITY_LIST, function (state, list) {
	  state.open_city_list = list;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_OPEN_CITY_LIST_FORMAT, function (state, list) {
	  state.open_city_list_format = list;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_RECENT_PRICE, function (state, price) {
	  state.recent_price = price;
	  window.localStorage.setItem('recent_price', price);
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_TOTAL_PRICE, function (state, price) {
	  state.total_price = price;
	  window.localStorage.setItem('total_price', price);
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.RESET_SELECTED_BUS, function (state) {
	  state.bus_list.splice(0, state.bus_list.length);
	  state.bus_bill.splice(0, state.bus_bill.length);
	  state.current_bus = {};
	  state.current_bus_info = {};
	  state.recent_price = null;
	  window.localStorage.setItem('recent_price', null);
	  state.total_price = null;
	  window.localStorage.setItem('total_price', null);
	}), _mutations);
	
	var actions = {
	  setCurrentBus: function setCurrentBus(_ref3, index) {
	    var commit = _ref3.commit,
	        state = _ref3.state;
	
	    var _current_bus = state.bus_list[index];
	    commit('UPDATE_CURRENT_BUS', _current_bus);
	    commit('UPDATE_CURRENT_BUS_INFO', {
	      total_price: _current_bus.car_price,
	      pricing_type: _current_bus.car_price
	    });
	  },
	  setOrderType: function setOrderType(_ref4, type) {
	    var commit = _ref4.commit;
	
	    commit('UPDATE_ORDER_TYPE', type);
	  },
	  setBusinessType: function setBusinessType(_ref5, type) {
	    var commit = _ref5.commit;
	
	    commit('UPDATE_BUSINESS_TYPE', type);
	  },
	  setSelectedBusList: function setSelectedBusList(_ref6) {
	    var commit = _ref6.commit,
	        state = _ref6.state;
	
	    var selected_list = JSON.parse(window.localStorage.getItem('bus_selected_list')) || [];
	    for (var i = 0; i < selected_list.length; i++) {
	      for (var t = 0; t < state.bus_list.length; t++) {
	        if (state.bus_list[t].car_type_id === selected_list[i].car_type_id) {
	          state.bus_list[t].bus_num = selected_list[i].bus_num;
	          var _param = {
	            car_type_id: state.bus_list[t].car_type_id,
	            car_type_name: state.bus_list[t].car_type_name,
	            seat_num: state.bus_list[t].seat_num,
	            bus_num: selected_list[i].bus_num,
	            price: state.bus_list[t].car_price,
	            baggage_num: state.bus_list[t].baggage_num
	          };
	          if (state.bus_list[t].pricing_type === 1) {
	            _param.price = state.current_bus_info.total_price;
	          }
	          commit('UPDATE_BUS_BILL', _param);
	        }
	      }
	    }
	  },
	  setSZHKType: function setSZHKType(_ref7, type) {
	    var commit = _ref7.commit;
	
	    commit('UPDATE_SZHK_TYPE', type);
	  },
	  setStartDate: function setStartDate(_ref8, date) {
	    var commit = _ref8.commit;
	
	    commit('UPDATE_START_TIME', date);
	  },
	  setEndDate: function setEndDate(_ref9, date) {
	    var commit = _ref9.commit;
	
	    commit('UPDATE_END_TIME', date);
	  },
	  setOrderDay: function setOrderDay(_ref10, day_num) {
	    var commit = _ref10.commit;
	
	    commit('UPDATE_ORDER_DAY', day_num);
	  },
	  setOrderDayRange: function setOrderDayRange(_ref11, range) {
	    var commit = _ref11.commit;
	
	    commit('UPDATE_ORDER_RANGE', range);
	  },
	  addOneBus: function addOneBus(_ref12, id) {
	    var commit = _ref12.commit,
	        state = _ref12.state;
	
	    var _find = false;
	    id = id || state.current_bus.car_type_id;
	    for (var i = 0, len = state.bus_bill.length; i < len; i++) {
	      if (state.bus_bill[i].car_type_id === id) {
	        _find = true;
	        commit('UPDATE_BUS_BILL_NUM', {
	          index: i,
	          type: 'add'
	        });
	        break;
	      }
	    }
	    if (!_find) {
	      var _param = {
	        car_type_id: state.current_bus.car_type_id,
	        car_type_name: state.current_bus.car_type_name,
	        seat_num: state.current_bus.seat_num,
	        bus_num: 1,
	        price: state.current_bus.car_price,
	        baggage_num: state.current_bus.baggage_num
	      };
	      if (state.current_bus_info.pricing_type === 1) {
	        _param.price = state.current_bus_info.total_price;
	      }
	      commit('UPDATE_BUS_BILL', _param);
	    }
	  },
	  reduceOneBus: function reduceOneBus(_ref13, id) {
	    var commit = _ref13.commit,
	        state = _ref13.state;
	
	    id = id || state.current_bus.car_type_id;
	    for (var i = 0, len = state.bus_bill.length; i < len; i++) {
	      if (state.bus_bill[i].car_type_id === id) {
	        commit('UPDATE_BUS_BILL_NUM', {
	          index: i,
	          type: 'reduce'
	        });
	        break;
	      }
	    }
	  },
	  getCarPhoto: function getCarPhoto(_ref14, params) {
	    var commit = _ref14.commit,
	        rootState = _ref14.rootState;
	
	    return new _promise2.default(function (resolve, reject) {
	      params = (0, _actions.RequestControl)(rootState, params);
	      _superagent2.default.post('/index.php/charter/mine/get_car_type_info').send(params).type('form').end(function (err, res) {
	        if (err) throw err;
	        var _res = JSON.parse(res.text);
	        if (_res.result === '0000') {
	          resolve(_res);
	        } else {
	          reject(_res);
	        }
	      });
	    });
	  },
	  setRecentPrice: function setRecentPrice(_ref15, price) {
	    var commit = _ref15.commit,
	        state = _ref15.state;
	
	    commit('UPDATE_RECENT_PRICE', price);
	  },
	  setTotalPrice: function setTotalPrice(_ref16, price) {
	    var commit = _ref16.commit,
	        state = _ref16.state;
	
	    commit('UPDATE_TOTAL_PRICE', price);
	  },
	  sendCancleReason: function sendCancleReason(_ref17, params) {
	    var commit = _ref17.commit,
	        state = _ref17.state,
	        rootState = _ref17.rootState;
	
	    return new _promise2.default(function (resolve, reject) {
	      params = (0, _actions.RequestControl)(rootState, params);
	      _superagent2.default.post('/index.php/charter/mine/cancel_order_reason').type('form').send(params).end(function (err, res) {
	        if (err) {
	          throw err;
	        }
	        var _res = JSON.parse(res.text);
	        if (_res.result === '0000') {
	          resolve(_res);
	        } else {
	          (0, _actions.RequestCommonResponse)(rootState, _res, reject);
	        }
	      });
	    });
	  }
	};
	
	exports.default = {
	  actions: actions,
	  state: state,
	  mutations: mutations
	};

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(60);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _defineProperty2 = __webpack_require__(86);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _mutationTypes = __webpack_require__(85);
	
	var _superagent = __webpack_require__(64);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _wx_share = __webpack_require__(166);
	
	var _wx_share2 = _interopRequireDefault(_wx_share);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  user_id: null,
	  user_phone: null,
	  user_head: null,
	  token: null };
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_USER_ID, function (state, user_id) {
	  state.user_id = user_id;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_USER_PHONE, function (state, user_phone) {
	  state.user_phone = user_phone;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_USER_HEAD, function (state, user_head) {
	  state.user_head = user_head;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.SET_USER_TOKEN, function (state, token) {
	  state.token = token;
	}), _mutations);
	
	var actions = {
	  setUserInfo: function setUserInfo(_ref, params) {
	    var commit = _ref.commit;
	
	    commit('UPDATE_USER_ID', params.user_id ? params.user_id : '');
	    commit('UPDATE_USER_PHONE', params.mobile ? params.mobile : '');
	    commit('SET_USER_TOKEN', params.token ? params.token : '');
	  },
	  getCode: function getCode(_ref2, params) {
	    var commit = _ref2.commit;
	
	    if (params) {
	      params.channel = '1';
	    }
	    return new _promise2.default(function (resolve, reject) {
	      _superagent2.default.post('/index.php/sms/code/send_new').send(params).type('form').end(function (err, res) {
	        if (err) throw err;
	        var _res = JSON.parse(res.text);
	        if (_res.result === '0000') {
	          resolve(_res);
	        } else {
	          reject(_res);
	        }
	      });
	    });
	  },
	  userLogin: function userLogin(_ref3, params) {
	    var commit = _ref3.commit;
	
	    return new _promise2.default(function (resolve, reject) {
	      _superagent2.default.post('/index.php/users/login/login_new').set('Accept', 'application/json').send(params).type('form').end(function (err, res) {
	        if (err) throw err;
	        var _res = JSON.parse(res.text);
	        if (_res.result === '0000') {
	          resolve(_res);
	        } else {
	          reject(_res);
	        }
	      });
	    });
	  },
	  authorLogin: function authorLogin(_ref4, params) {
	    var commit = _ref4.commit;
	
	    return new _promise2.default(function (resolve, reject) {
	      _superagent2.default.post('/index.php/zuolinauth/zuolin_login').set('Accept', 'application/json').send(params).type('form').end(function (err, res) {
	        if (err) throw err;
	        var _res = JSON.parse(res.text);
	        if (_res.result === '0000') {
	          resolve(_res);
	        } else {
	          reject(_res);
	        }
	      });
	    });
	  },
	  userLogout: function userLogout(_ref5, params) {
	    var commit = _ref5.commit;
	
	    return new _promise2.default(function (resolve, reject) {
	      _superagent2.default.post('/index.php/users/mine/login_out').set('Accept', 'application/json').send(params).type('form').end(function (err, res) {
	        if (err) throw err;
	        var _res = JSON.parse(res.text);
	        if (_res.result === '0000') {
	          resolve(_res);
	        } else {
	          reject(_res);
	        }
	      });
	    });
	  },
	  autoLogin: function autoLogin(_ref6) {
	    var commit = _ref6.commit;
	
	    return new _promise2.default(function (resolve, reject) {
	      _superagent2.default.post('/index.php/users/mine/auto_login').type('form').end(function (err, res) {
	        if (err) throw err;
	        var _res = JSON.parse(res.text);
	        if (_res.result === '0000') {
	          if (_res.data.login) {
	            commit(_mutationTypes.UPDATE_USER_ID, _res.data.ltb_user_id);
	            commit(_mutationTypes.UPDATE_USER_PHONE, _res.data.user_name);
	            commit(_mutationTypes.UPDATE_USER_HEAD, _res.data.user_head_img);
	          } else {}
	          resolve(_res);
	        } else {
	          reject(_res);
	        }
	      });
	    });
	  },
	  wxShare: function wxShare(_ref7) {
	    var commit = _ref7.commit;
	
	    return new _promise2.default(function (resolve, reject) {
	      _superagent2.default.post('/index.php/users/weixin/get_wx_sign_package').send({
	        share_url: window.location.href
	      }).type('form').end(function (err, res) {
	        if (err) throw err;
	        var _res = void 0;
	        if (res.text && res.text.result) {
	          _res = JSON.parse(res.text);
	        } else {
	          _res = JSON.parse(res.xhr.response);
	        }
	        if (_res && _res.result === '0000') {
	          (0, _wx_share2.default)(_res.data);
	        } else {}
	      });
	    });
	  }
	};
	
	exports.default = {
	  actions: actions,
	  state: state,
	  mutations: mutations
	};

/***/ }),

/***/ 188:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 207:
/***/ (function(module, exports) {

	"use strict";
	
	(function (win, lib) {
	  var doc = win.document;
	  var docEl = doc.documentElement;
	  var metaEl = doc.querySelector("meta[name = 'viewport']");
	  var flexibleEl = doc.querySelector("meta[name = 'flexible']");
	  var dpr = 0;
	  var scale = 0;
	  var tid;
	  var flexible = lib.flexible || (lib.flexible = {});
	  if (metaEl) {
	    console.warn('将根据已有的meta标签来设置缩放比例');
	    var match = metaEl.getAttribute('content').match(/initial\-scale=([\d\.]+)/);
	    if (match) {
	      scale = parseFloat(match[1]);
	      dpr = parseInt(1 / scale);
	    }
	  } else if (flexibleEl) {
	    var content = flexibleEl.getAttribute('content');
	    if (content) {
	      var initialDpr = content.match(/initial\-dpr = ([\d\.]+)/);
	      var maximumDpr = content.match(/maximum\-dpr = ([\d\.]+)/);
	      if (initialDpr) {
	        dpr = parseFloat(initialDpr[1]);
	        scale = parseFloat((1 / dpr).toFixed(2));
	      }
	      if (maximumDpr) {
	        dpr = parseFloat(maximumDpr[1]);
	        scale = parseFloat((1 / dpr).toFixed(2));
	      }
	    }
	  }
	  if (!dpr && !scale) {
	    var isIPhone = win.navigator.appVersion.match(/iphone/gi);
	    var devicePixelRatio = win.devicePixelRatio;
	    if (isIPhone) {
	      if (devicePixelRatio >= 3 && (!dpr || dpr >= 3)) {
	        dpr = 3;
	      } else if (devicePixelRatio >= 2 && (!dpr || dpr >= 2)) {
	        dpr = 2;
	      } else {
	        dpr = 1;
	      }
	    } else {
	      dpr = 1;
	    }
	    scale = 1 / dpr;
	  }
	
	  if (!metaEl) {
	    metaEl = doc.createElement('meta');
	    metaEl.setAttribute('name', 'viewport');
	    metaEl.setAttribute('content', 'initial - scale=' + scale + ', maximum - scale=' + scale + ', minimum - scale=' + scale + ', user - scalable=no');
	    if (docEl.firstElementChild) {
	      docEl.firstElementChild.appendChild(metaEl);
	    } else {
	      var wrap = doc.createElement('div');
	      wrap.appendChild(metaEl);
	      doc.write(wrap.innerHTML);
	    }
	  }
	  function refreshRem() {
	    var width = docEl.getBoundingClientRect().width;
	    if (width / dpr > 540) {
	      width = 540 * dpr;
	    }
	    var rem = width / 10;
	    docEl.style.fontSize = rem + 'px';
	    flexible.rem = win.rem = rem;
	  }
	  win.addEventListener('resize', function () {
	    clearTimeout(tid);
	    tid = setTimeout(refreshRem, 300);
	  }, false);
	  win.addEventListener('pageshow', function (e) {
	    if (e.persisted) {
	      clearTimeout(tid);
	      tid = setTimeout(refreshRem, 300);
	    }
	  }, false);
	  if (doc.readyState === 'complete') {
	    doc.body.style.fontSize = 12 * dpr + 'px';
	  } else {
	    doc.addEventListener('DOMContentLoaded', function (e) {
	      doc.body.style.fontSize = 12 * dpr + 'px';
	    }, false);
	  }
	  refreshRem();
	  flexible.dpr = win.dpr = dpr;
	  flexible.refreshRem = refreshRem;
	  flexible.rem2px = function (d) {
	    var val = parseFloat(d) * this.rem;
	    if (typeof d === 'string' && d.match(/rem$/)) {
	      val += 'px';
	    }
	    return val;
	  };
	  flexible.px2rem = function (d) {
	    var val = parseFloat(d) / this.rem;
	    if (typeof d === 'string' && d.match(/px$/)) {
	      val += 'rem';
	    }
	    return val;
	  };
	})(window, window['lib'] || (window['lib'] = {}));

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _stringify = __webpack_require__(16);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _typeof2 = __webpack_require__(67);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appid = '56CC095378589F7998EE1331E25C01A6';
	var vn = '嘟嘟巴士包车H5端';
	var vc = '1.0';
	var TDBaseUrl = 'https://jic.talkingdata.com/app/h5/v1/websdk';
	var TDRequestUrl = 'https://h5.udrig.com/app/v1';
	
	function createScriptTd(url) {
	  var _head = document.getElementsByTagName('head')[0];
	  var _script = document.createElement('script');
	  _script.type = 'text/javascript';
	  _script.src = url;
	  _head.appendChild(_script);
	};
	createScriptTd(TDBaseUrl + '/js/sdk_release.js');
	if (!window['JSON'] || (typeof JSON === 'undefined' ? 'undefined' : (0, _typeof3.default)(JSON)) !== 'object') {
	  createScriptTd(TDBaseUrl + '/js/json2.js');
	}
	window["TDAPP"] = {};
	window["TDAPP"].onEvent = function (id, label, params) {
	  if (arguments.length > 0) {
	    try {
	      var opts = {
	        count: 1,
	        start: new Date().getTime()
	      };
	      if (id != undefined) {
	        opts["id"] = typeof id != "string" ? (0, _stringify2.default)(id) : id;
	      }
	      if (label != undefined) {
	        opts["label"] = typeof label != "string" ? (0, _stringify2.default)(label) : label;
	      } else {
	        opts["label"] = "";
	      }
	      if (params != undefined) {
	        var isJson = function isJson(obj) {
	          var isjson = (typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) == "object" && Object.prototype.toString.call(obj).toLowerCase() == "[object object]" && !obj.length;
	          return isjson;
	        };
	        if (isJson(params)) {
	          opts["params"] = params;
	        } else {
	          opts["params"] = {
	            params: ""
	          };
	        }
	      }
	      var eventName = "__TD_td-init-event";
	      var ev = localStorage[eventName];
	      if (ev) {
	        var ca = JSON.parse(ev);
	        ca.push(opts);
	        localStorage.setItem(eventName, (0, _stringify2.default)(ca));
	        return;
	      };
	      localStorage.setItem(eventName, "[" + (0, _stringify2.default)(opts) + "]");
	    } catch (e) {}
	  }
	};
	
	window['appid'] = '56CC095378589F7998EE1331E25C01A6';
	window['vn'] = '嘟嘟巴士包车H5端';
	window['vc'] = '1.0';
	window['TDBaseUrl'] = 'https://jic.talkingdata.com/app/h5/v1/websdk';
	window['TDRequestUrl'] = 'https://h5.udrig.com/app/v1';

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(16);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _vue = __webpack_require__(59);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuexRouterSync = __webpack_require__(433);
	
	var _vueRouter = __webpack_require__(432);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _index = __webpack_require__(167);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _util = __webpack_require__(7);
	
	var _Enterprise = __webpack_require__(396);
	
	var _Enterprise2 = _interopRequireDefault(_Enterprise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var router = new _vueRouter2.default({
	  base: '/baoche_frontend/dist',
	  mode: 'history',
	  routes: [{
	    name: 'home',
	    path: '/',
	
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(3, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(198)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    meta: {
	      title: '包车下单',
	      need_login: false
	    }
	  }, {
	    name: 'orderVehicle',
	    path: '/orderVehicle',
	
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(3/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(198)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    meta: {
	      title: '包车下单',
	      need_login: false
	    }
	  }, {
	    path: '/search/:type/:index',
	
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(0, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(112)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    meta: {
	      title: '包车下单',
	      need_login: false
	    }
	  }, {
	    path: '/search/:type',
	
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(0/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(112)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    meta: {
	      title: '包车下单',
	      need_login: false
	    }
	  }, {
	    name: 'selectBus',
	    path: '/select/bus',
	
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(17, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(393)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    meta: {
	      title: '请选择车辆',
	      need_login: true
	    }
	  }, {
	    name: 'confirmOrder',
	    path: '/confirmOrder',
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(19, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(394)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    meta: {
	      title: '填写信息',
	      need_login: true
	    }
	  }, {
	    name: 'orderDetail',
	    path: '/orderDetail/:orderId',
	
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(14, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(391)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    meta: {
	      title: '订单详情',
	      need_login: true
	    }
	  }, {
	    name: 'orderDetailRo',
	    path: '/orderDetailRo/:orderId',
	
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(2, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(197)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    meta: {
	      title: '订单详情',
	      need_login: false
	    }
	  }, {
	    name: 'commitSuccess',
	    path: '/commitSuccess/:orderId',
	
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(23, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(388)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    meta: {
	      title: '提交成功',
	      need_login: true
	    }
	  }, {
	    name: 'login',
	    path: '/login',
	
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(10, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(196)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    meta: {
	      title: '登录',
	      need_login: false
	    }
	  }, {
	    name: 'author',
	    path: '/author',
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(13, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(194)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    meta: {
	      title: '授权',
	      need_login: false
	    }
	  }, {
	    name: 'pay',
	    path: '/pay/:orderId/:payState',
	
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(5, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(199)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    meta: {
	      title: '支付页面',
	      need_login: true
	    }
	  }, {
	    name: 'paySuccess',
	    path: '/paySuccess/:orderId',
	
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(7, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(200)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    meta: {
	      title: '支付成功',
	      need_login: true
	    }
	  }, {
	    name: 'myOrder',
	    path: '/myOrder',
	
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(21, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(390)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    meta: {
	      title: '我的订单',
	      need_login: true
	    }
	  }, {
	    name: 'coupon',
	    path: '/coupon/:type',
	
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(1, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(111)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    meta: {
	      title: '优惠卡劵',
	      need_login: true
	    }
	  }, {
	    name: 'selectCoupon',
	    path: '/chooseCoupon/:type/:orderId',
	
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(1/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(111)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    meta: {
	      title: '选择优惠卡券',
	      need_login: true
	    }
	  }, {
	    name: 'historyCoupon',
	    path: '/historyCoupon',
	
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(11, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(195)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    meta: {
	      title: '历史券',
	      need_login: true
	    }
	  }, {
	    name: 'question',
	    path: '/question',
	
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(9, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(202)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    meta: {
	      title: '常见问题',
	      need_login: false
	    }
	  }, {
	    name: 'service',
	    path: '/service',
	
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(12, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(201)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    meta: {
	      title: '服务协议',
	      need_login: false
	    }
	  }, {
	    name: 'rater',
	    path: '/rater/:type/:orderId',
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(6, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(193)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    meta: {
	      title: '评价',
	      need_login: true
	    }
	  }, {
	    name: 'introduce2',
	    path: '/introduce2',
	
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(25, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(389)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    meta: {
	      title: '包车找嘟嘟',
	      need_login: false
	    }
	  }, {
	    name: 'selectCity',
	    path: '/selectCity',
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(8, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(203)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    },
	    meta: {
	      title: '选择城市',
	      need_login: false
	    }
	  }, {
	    path: '/e/:enterprise_id',
	    name: 'enterprise',
	    component: _Enterprise2.default,
	    meta: {
	      need_login: false
	    },
	    children: [{
	      name: 'home',
	      path: '/',
	      component: function component(resolve) {
	        __webpack_require__.e/* require */(4, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(204)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      },
	      meta: {
	        title: '包车下单',
	        need_login: false
	      }
	    }, {
	      name: 'orderVehicle',
	      path: 'orderVehicle',
	      component: function component(resolve) {
	        __webpack_require__.e/* require */(4/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(204)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      },
	      meta: {
	        title: '包车下单',
	        need_login: false
	      }
	    }, {
	      path: 'search/:type/:index',
	      component: function component(resolve) {
	        __webpack_require__.e/* require */(0/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(112)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      },
	      meta: {
	        title: '包车下单',
	        need_login: false
	      }
	    }, {
	      path: 'search/:type',
	      component: function component(resolve) {
	        __webpack_require__.e/* require */(0/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(112)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      },
	      meta: {
	        title: '包车下单',
	        need_login: false
	      }
	    }, {
	      name: 'selectBus',
	      path: 'select/bus',
	      component: function component(resolve) {
	        __webpack_require__.e/* require */(16, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(400)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      },
	      meta: {
	        title: '请选择车辆',
	        need_login: true
	      }
	    }, {
	      name: 'confirmOrder',
	      path: 'confirmOrder',
	      component: function component(resolve) {
	        __webpack_require__.e/* require */(18, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(401)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      },
	      meta: {
	        title: '填写信息',
	        need_login: true
	      }
	    }, {
	      name: 'orderDetail',
	      path: 'orderDetail/:orderId',
	      component: function component(resolve) {
	        __webpack_require__.e/* require */(15, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(399)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      },
	      meta: {
	        title: '订单详情',
	        need_login: true
	      }
	    }, {
	      name: 'orderDetailRo',
	      path: 'orderDetailRo/:orderId',
	      component: function component(resolve) {
	        __webpack_require__.e/* require */(2/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(197)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      },
	      meta: {
	        title: '订单详情',
	        need_login: false
	      }
	    }, {
	      name: 'commitSuccess',
	      path: 'commitSuccess/:orderId',
	      component: function component(resolve) {
	        __webpack_require__.e/* require */(22, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(395)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      },
	      meta: {
	        title: '提交成功',
	        need_login: true
	      }
	    }, {
	      name: 'login',
	      path: 'login',
	      component: function component(resolve) {
	        __webpack_require__.e/* require */(10/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(196)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      },
	      meta: {
	        title: '登录',
	        need_login: false
	      }
	    }, {
	      name: 'author',
	      path: 'author',
	      component: function component(resolve) {
	        __webpack_require__.e/* require */(13/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(194)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      },
	      meta: {
	        title: '授权',
	        need_login: false
	      }
	    }, {
	      name: 'pay',
	      path: 'pay/:orderId/:payState',
	      component: function component(resolve) {
	        __webpack_require__.e/* require */(5/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(199)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      },
	      meta: {
	        title: '支付页面',
	        need_login: true
	      }
	    }, {
	      name: 'paySuccess',
	      path: 'paySuccess/:orderId',
	      component: function component(resolve) {
	        __webpack_require__.e/* require */(7/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(200)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      },
	      meta: {
	        title: '支付成功',
	        need_login: true
	      }
	    }, {
	      name: 'myOrder',
	      path: 'myOrder',
	      component: function component(resolve) {
	        __webpack_require__.e/* require */(20, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(398)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      },
	      meta: {
	        title: '我的订单',
	        need_login: true
	      }
	    }, {
	      name: 'coupon',
	      path: 'coupon/:type',
	      component: function component(resolve) {
	        __webpack_require__.e/* require */(1/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(111)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      },
	      meta: {
	        title: '优惠卡劵',
	        need_login: true
	      }
	    }, {
	      name: 'selectCoupon',
	      path: 'chooseCoupon/:type/:orderId',
	      component: function component(resolve) {
	        __webpack_require__.e/* require */(1/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(111)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      },
	      meta: {
	        title: '选择优惠卡券',
	        need_login: true
	      }
	    }, {
	      name: 'historyCoupon',
	      path: 'historyCoupon',
	      component: function component(resolve) {
	        __webpack_require__.e/* require */(11/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(195)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      },
	      meta: {
	        title: '历史券',
	        need_login: true
	      }
	    }, {
	      name: 'question',
	      path: 'question',
	      component: function component(resolve) {
	        __webpack_require__.e/* require */(9/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(202)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      },
	      meta: {
	        title: '常见问题',
	        need_login: false
	      }
	    }, {
	      name: 'service',
	      path: 'service',
	      component: function component(resolve) {
	        __webpack_require__.e/* require */(12/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(201)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      },
	      meta: {
	        title: '服务协议',
	        need_login: false
	      }
	    }, {
	      name: 'rater',
	      path: 'rater/:type/:orderId',
	      component: function component(resolve) {
	        __webpack_require__.e/* require */(6/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(193)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      },
	      meta: {
	        title: '评价',
	        need_login: true
	      }
	    }, {
	      name: 'introduce2',
	      path: 'introduce2',
	      component: function component(resolve) {
	        __webpack_require__.e/* require */(24, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(397)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      },
	      meta: {
	        title: '用车流程',
	        need_login: false
	      }
	    }, {
	      name: 'selectCity',
	      path: 'selectCity',
	      component: function component(resolve) {
	        __webpack_require__.e/* require */(8/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(203)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	      },
	      meta: {
	        title: '选择城市',
	        need_login: false
	      }
	    }]
	  }]
	});
	
	var history = window.sessionStorage;
	var historyCount = history.getItem('count') * 1 || 0;
	var init_dudu_app = false;
	var init_h5 = false;
	var init_wx = false;
	var init_page_router = false;
	history.setItem('/', 0);
	
	function initWX() {
	  if (!init_wx && _index2.default.getters.is_weixin_browser) {
	    init_wx = true;
	
	    setTimeout(function () {
	      _index2.default.dispatch('wxShare');
	    }, 100);
	  }
	}
	
	function setPatch(patch) {
	  var _patch = patch;
	  if (_index2.default.getters.enterprise_id) {
	    _patch = '/e/' + _index2.default.getters.enterprise_id + _patch;
	  }
	  return _patch;
	}
	router.beforeEach(function (to, from, next) {
	  if (!init_page_router && to.params.enterprise_id) {
	    _index2.default.commit('UPDATE_ENTERPRISE_ID', to.params.enterprise_id);
	    init_page_router = true;
	  }
	  if ((to.query.os === '25' || to.query.os === '28') && to.name === 'home' && !_index2.default.getters.is_login && (!to.query.check_author || to.query.check_author !== 'no')) {
	    getAuthor(to);
	  } else if (_index2.default.getters.enterprise_id && !to.params.enterprise_id) {
	    router.push({
	      path: setPatch(to.path),
	      query: to.query
	    });
	    next();
	  } else if (to.name === 'author') {
	    next();
	  } else {
	    goNext();
	  }
	  function getAuthor(to) {
	    window.localStorage.setItem('from_query', (0, _stringify2.default)(to.query));
	    var _client_id = '';
	    var _site = '';
	    var _redirect_uri = window.location.href.split('?')[0];
	    _redirect_uri = _redirect_uri.charAt(_redirect_uri.length - 1) === '/' ? encodeURIComponent(_redirect_uri + setPatch('author')) : encodeURIComponent(_redirect_uri + setPatch('/author'));
	    if (to.query.os === '25') {
	      _client_id = 'ce48c658-46bb-48e4-8ecc-99d2c375c6c2';
	      _site = 'https://core.zuolin.com/evh/oauth2/authorize';
	    } else if (to.query.os === '28') {
	      _client_id = '3130b2c3-2cb0-4fe7-9b35-4440a6fe0c84';
	      _site = 'https://park.szbay.com/evh/oauth2/authorize';
	    }
	    window.location.href = _site + '?response_type=code&client_id=' + _client_id + '&redirect_uri=' + _redirect_uri + '&scope=basic&state=dudubashi_baoche#oauth2_redirect';
	  }
	
	  function goNext() {
	    if ((from.name === 'pay' || from.name === 'commitSuccess' || from.name === 'orderDetail' || from.name === 'orderDetailRo') && to.name === 'selectBus') {
	      router.replace({ path: setPatch('/orderVehicle') });
	      next();
	    }
	
	    var toIndex = history.getItem(to.path);
	    var fromIndex = history.getItem(from.path);
	
	    if (toIndex) {
	      if (toIndex > fromIndex || !fromIndex) {
	        _index2.default.commit('UPDATE_DIRECTION', 'forward');
	      } else {
	        _index2.default.commit('UPDATE_DIRECTION', 'reverse');
	      }
	    } else {
	      ++historyCount;
	      history.setItem('count', historyCount);
	      to.path !== '/' && history.setItem(to.path, historyCount);
	      _index2.default.commit('UPDATE_DIRECTION', 'forward');
	    }
	    if (from.path) {
	      _index2.default.commit('UPDATE_PAGE_FROM', from.path);
	    }
	    _index2.default.commit('UPDATE_LOADING', true);
	    for (var i = 0, _inputs = document.getElementsByTagName('input'), len = _inputs.length; i < len; i++) {
	      _inputs[0].blur();
	    }
	    var _back_url = to.path !== '/' ? from.path : null;
	    switch (to.name) {
	      case 'myOrder':
	        _back_url = '/orderVehicle';
	        break;
	      case 'selectBus':
	        _back_url = '/orderVehicle';
	        break;
	      case 'confirmOrder':
	        _back_url = '/orderVehicle';
	        break;
	      case 'orderDetail':
	        if (from.name !== 'myOrder') {
	          _back_url = '/myOrder';
	        }
	        break;
	      case 'coupon':
	        if (from.name === 'historyCoupon') {
	          _back_url = '/orderVehicle';
	        }
	        break;
	      case 'orderVehicle':
	        _back_url = null;
	        break;
	      case 'paySuccess':
	        _back_url = null;
	        break;
	      case 'login':
	        if (_index2.default.getters.is_login) {
	          router.replace('/orderVehicle');
	        }
	        break;
	    }
	    _index2.default.commit('UPDATE_BACK_PATH', setPatch(_back_url));
	
	    if (to.query.os === '1' || to.query.os === '2') {
	      if (!init_dudu_app) {
	        init_dudu_app = true;
	        _index2.default.dispatch('setAppParams', to.query);
	        _index2.default.dispatch('setUserInfo', to.query);
	      }
	    } else if (to.query.os) {
	      _index2.default.dispatch('setOS', to.query.os);
	    }
	
	    if (init_dudu_app) {
	      if (_index2.default.getters.os === '1') {
	        (0, _util.setupWebViewJavascriptBridge)(function (bridge) {
	          bridge.callHandler('setNavigationBarTitle', to.meta ? to.meta.title : '');
	        });
	
	        if (to.name === 'orderVehicle' || to.name === 'home' && to.query.firstuse !== '1') {
	          (0, _util.setupWebViewJavascriptBridge)(function (bridge) {
	            bridge.callHandler('showRightBarButtonItem', { show: '1' });
	          });
	        } else {
	          (0, _util.setupWebViewJavascriptBridge)(function (bridge) {
	            bridge.callHandler('showRightBarButtonItem', { show: '0' });
	          });
	        }
	      } else if (_index2.default.getters.os === '2') {
	        try {
	          window.app.setNavigationBarTitle(to.meta ? to.meta.title : '');
	        } catch (e) {
	          console.warn('== 出现错误, 如果在非android环境下访问, 出现该警告是正常的.');
	        }
	        if (to.name === 'orderVehicle' || to.name === 'home' && to.query.firstuse !== '1') {
	          try {
	            window.app.showRightBarButtonItem('1');
	          } catch (e) {
	            console.warn('== 出现错误, 如果在非android环境下访问, 出现该警告是正常的.');
	          }
	        } else {
	          try {
	            window.app.showRightBarButtonItem('0');
	          } catch (e) {
	            console.warn('== 出现错误, 如果在非android环境下访问, 出现该警告是正常的.');
	          }
	        }
	      }
	    }
	
	    if (!init_wx) {
	      init_wx = true;
	      initWX();
	    }
	    if (_index2.default.getters.is_app) {
	      setTimeout(next, 50);
	    } else {
	      if (to.meta.need_login) {
	        if (!init_h5 && !_index2.default.getters.is_login) {
	          init_h5 = true;
	          var _result = _index2.default.dispatch('autoLogin');
	          _result.then(function (_res) {
	            if (!_res.data.login && to.name !== 'orderVehicle' && to.name !== 'home' && to.name !== 'question' && to.name !== 'introduce2') {
	              var _query = to.query;
	              _query.backurl = to.path.split('/')[1];
	              _query.routeurl = to.params;
	
	              if (window.location.href.indexOf('refer=sms') !== -1) {
	                window.localStorage.setItem('refer', 'sms');
	              }
	              router.replace({ path: setPatch('/login'), query: _query });
	            }
	            next();
	          });
	        } else {
	          if (_index2.default.getters.is_login) {
	            next();
	          } else {
	            var _query = to.query;
	            _query.backurl = to.path.split('/')[1];
	            _query.routeurl = to.params;
	            router.replace({ path: setPatch('/login'), query: _query });
	          }
	        }
	      } else {
	        if (!init_h5 && !_index2.default.getters.is_login) {
	          init_h5 = true;
	          _index2.default.dispatch('autoLogin');
	        }
	        next();
	      }
	    }
	  }
	});
	
	router.afterEach(function () {
	  _index2.default.commit('UPDATE_LOADING', false);
	});
	
	(0, _vuexRouterSync.sync)(_index2.default, router);
	
	exports.default = router;

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enterprise_server_phone = exports.enterprise_id = exports.tips_add_site = exports.qiyu_staff_id = exports.qiyu_group_id = exports.include_hk = exports.line_distance = exports.szhk_end_city = exports.szhk_start_city = exports.invoice_info = exports.select_coupon = exports.open_city_list_format = exports.open_city_list = exports.bus_total_price = exports.bus_bill_seat_bag = exports.bus_bill_seat = exports.current_bus_selected_num = exports.selected_bus_list = exports.current_bus_info = exports.current_bus = exports.bus_list = exports.banner_list = exports.if_szhk_submit_single = exports.if_szhk_submit_round = exports.szhk_end_address = exports.szhk_way_address = exports.szhk_start_address = exports.if_submit_day = exports.if_submit_single = exports.if_submit_round = exports.way_address = exports.end_address_province = exports.end_address_city = exports.end_address = exports.start_address_province = exports.start_address_city = exports.current_city = exports.select_open_city = exports.start_address = exports.order_szhk_type = exports.order_business_type = exports.order_type = exports.default_end_time = exports.default_start_time = exports.end_time = exports.start_time = exports.user_real_phone = exports.user_phone = exports.innerHeight = exports.show_qiyu = exports.show_app_qiyu = exports.fee_config = exports.is_android = exports.isiOS = exports.is_weixin_browser = exports.show_jump_coupons_btn = exports.os = exports.is_app = exports.is_login = exports.handleTokenError = exports.reload_page = undefined;
	
	var _util = __webpack_require__(7);
	
	var reload_page = exports.reload_page = function reload_page(state) {
	  return state.common.reload_page;
	};
	var handleTokenError = exports.handleTokenError = function handleTokenError(state) {
	  if (state.duduApp.os === '1' || state.duduApp.os === '2') {
	    if (state.duduApp.os === '1') {
	      return (0, _util.compare)(state.duduApp.app_version, '5.1.4') >= 0;
	    } else {
	      return state.duduApp.app_version >= 51;
	    }
	  } else {
	    return true;
	  }
	};
	
	var is_login = exports.is_login = function is_login(state) {
	  return state.userInfo.user_phone;
	};
	var is_app = exports.is_app = function is_app(state) {
	  if (state.duduApp.os === '1' || state.duduApp.os === '2') {
	    return true;
	  }
	};
	var os = exports.os = function os(state) {
	  return state.duduApp.os;
	};
	var show_jump_coupons_btn = exports.show_jump_coupons_btn = function show_jump_coupons_btn(state) {
	  if (state.duduApp.os === '1' || state.duduApp.os === '2') {
	    if (state.duduApp.os === '1') {
	      return (0, _util.compare)(state.duduApp.app_version, '5.1.1') > 0;
	    } else {
	      return state.duduApp.app_version > 47;
	    }
	  } else {
	    return true;
	  }
	};
	var is_weixin_browser = exports.is_weixin_browser = function is_weixin_browser(state) {
	  return state.common.is_weixin_browser;
	};
	var isiOS = exports.isiOS = function isiOS(state) {
	  return state.common.isiOS;
	};
	
	var is_android = exports.is_android = function is_android(state) {
	  return state.common.is_android;
	};
	var fee_config = exports.fee_config = function fee_config(state) {
	  return state.order.fee_config;
	};
	
	var show_app_qiyu = exports.show_app_qiyu = function show_app_qiyu(state) {
	  var _show = false;
	  if (state.duduApp.os === '1' || state.duduApp.os === '2' && Number(state.duduApp.app_version) > 46) {
	    _show = true;
	  }
	  return _show;
	};
	
	var show_qiyu = exports.show_qiyu = function show_qiyu(state) {
	  var _show = true;
	  if (state.duduApp.os === '2' && Number(state.duduApp.app_version) < 47) {
	    _show = false;
	  }
	  return _show;
	};
	
	var innerHeight = exports.innerHeight = function innerHeight(state) {
	  return window.innerHeight;
	};
	
	var user_phone = exports.user_phone = function user_phone(state) {
	  if (state.userInfo && state.userInfo.user_phone) {
	    var _phone = String(state.userInfo.user_phone);
	    return _phone.substring(0, 3) + '****' + _phone.substring(7);
	  } else {
	    return null;
	  }
	};
	
	var user_real_phone = exports.user_real_phone = function user_real_phone(state) {
	  return state.userInfo.user_phone;
	};
	
	var start_time = exports.start_time = function start_time(state) {
	  return state.order.start_time;
	};
	
	var end_time = exports.end_time = function end_time(state) {
	  return state.order.end_time;
	};
	
	var default_start_time = exports.default_start_time = function default_start_time(state) {
	  var _time;
	  if (state.order.start_time) {
	    _time = new Date(state.order.start_time.param);
	  } else {
	    var now_date = Date.parse(new Date());
	    var tomorrow_date = now_date + 86410000 + 300000;
	    _time = new Date(tomorrow_date);
	  }
	  return _time;
	};
	
	var default_end_time = exports.default_end_time = function default_end_time(state) {
	  var _time;
	  if (state.order.end_time) {
	    _time = new Date(state.order.end_time.param);
	  } else {
	    var now_date = Date.parse(new Date());
	    var tomorrow_date = now_date + 86410000 + 300000;
	    _time = new Date(tomorrow_date);
	  }
	  return _time;
	};
	
	var order_type = exports.order_type = function order_type(state) {
	  return state.order.type;
	};
	
	var order_business_type = exports.order_business_type = function order_business_type(state) {
	  return state.order.business_type;
	};
	
	var order_szhk_type = exports.order_szhk_type = function order_szhk_type(state) {
	  return state.order.szhk_type;
	};
	
	var start_address = exports.start_address = function start_address(state) {
	  return state.location.start_address;
	};
	
	var select_open_city = exports.select_open_city = function select_open_city(state) {
	  return state.location.select_open_city || state.location.current_city;
	};
	
	var current_city = exports.current_city = function current_city(state) {
	  return state.location.current_city;
	};
	
	var start_address_city = exports.start_address_city = function start_address_city(state) {
	  var _city = state.location.start_info ? state.location.start_info.split('-')[1] : null;
	  return _city;
	};
	
	var start_address_province = exports.start_address_province = function start_address_province(state) {
	  var _province = state.location.start_info ? state.location.start_info.split('-')[0] : null;
	  return _province;
	};
	
	var end_address = exports.end_address = function end_address(state) {
	  return state.location.end_address;
	};
	
	var end_address_city = exports.end_address_city = function end_address_city(state) {
	  var _city = state.location.end_info ? state.location.end_info.split('-')[1] : null;
	  return _city;
	};
	
	var end_address_province = exports.end_address_province = function end_address_province(state) {
	  var _province = state.location.end_info ? state.location.end_info.split('-')[0] : null;
	  return _province;
	};
	
	var way_address = exports.way_address = function way_address(state) {
	  return state.location.way_address;
	};
	
	var if_submit_round = exports.if_submit_round = function if_submit_round(state) {
	  var can_submit = false;
	  if (state.order.start_time && state.order.end_time && state.location.end_address && state.location.start_address) {
	    can_submit = true;
	  }
	  return can_submit;
	};
	var if_submit_single = exports.if_submit_single = function if_submit_single(state) {
	  var can_submit = false;
	  if (state.order.start_time && state.location.end_address && state.location.start_address) {
	    can_submit = true;
	  }
	  return can_submit;
	};
	
	var if_submit_day = exports.if_submit_day = function if_submit_day(state) {
	  var can_submit = false;
	  if (state.order.start_time && state.order.end_time && state.location.end_address && state.location.start_address) {
	    can_submit = true;
	  }
	  return can_submit;
	};
	
	var szhk_start_address = exports.szhk_start_address = function szhk_start_address(state) {
	  return state.location.szhk_start_address;
	};
	
	var szhk_way_address = exports.szhk_way_address = function szhk_way_address(state) {
	  return state.location.szhk_way_address;
	};
	
	var szhk_end_address = exports.szhk_end_address = function szhk_end_address(state) {
	  return state.location.szhk_end_address;
	};
	
	var if_szhk_submit_round = exports.if_szhk_submit_round = function if_szhk_submit_round(state) {
	  var can_submit = false;
	  if (state.order.start_time && state.order.end_time && state.location.szhk_end_address && state.location.szhk_start_address) {
	    can_submit = true;
	  }
	  return can_submit;
	};
	
	var if_szhk_submit_single = exports.if_szhk_submit_single = function if_szhk_submit_single(state) {
	  var can_submit = false;
	  if (state.order.start_time && state.location.szhk_end_address && state.location.szhk_start_address) {
	    can_submit = true;
	  }
	  return can_submit;
	};
	
	var banner_list = exports.banner_list = function banner_list(state) {
	  return state.common.banner_list;
	};
	
	var bus_list = exports.bus_list = function bus_list(state) {
	  if (state.order.bus_list.length) {
	    for (var i = 0, len = state.order.bus_list.length; i < len; i++) {
	      var _bus = state.order.bus_list[i];
	      if (_bus.seat_num <= 19) {
	        _bus.className = 'icon_new_bus_19';
	      } else if (_bus.seat_num <= 27) {
	        _bus.className = 'icon_new_bus_27';
	      } else if (_bus.seat_num <= 37) {
	        _bus.className = 'icon_new_bus_37';
	      } else {
	        _bus.className = 'icon_new_bus_55';
	      }
	    }
	    return state.order.bus_list;
	  } else {
	    return [];
	  }
	};
	
	var current_bus = exports.current_bus = function current_bus(state) {
	  return state.order.current_bus;
	};
	
	var current_bus_info = exports.current_bus_info = function current_bus_info(state) {
	  return state.order.current_bus_info;
	};
	
	var selected_bus_list = exports.selected_bus_list = function selected_bus_list(state) {
	  return state.order.bus_bill;
	};
	
	var current_bus_selected_num = exports.current_bus_selected_num = function current_bus_selected_num(state) {
	  var _num = 0;
	  for (var i = 0, len = state.order.bus_bill.length; i < len; i++) {
	    if (state.order.bus_bill[i].car_type_id === state.order.current_bus.car_type_id) {
	      _num = state.order.bus_bill[i].bus_num;
	      break;
	    }
	  }
	  return _num;
	};
	
	var bus_bill_seat = exports.bus_bill_seat = function bus_bill_seat(state) {
	  var _num = 0;
	  for (var i = 0, len = state.order.bus_bill.length; i < len; i++) {
	    _num += state.order.bus_bill[i].bus_num * state.order.bus_bill[i].seat_num;
	  }
	  return _num;
	};
	
	var bus_bill_seat_bag = exports.bus_bill_seat_bag = function bus_bill_seat_bag(state) {
	  var _bag = 0;
	  var _num = 0;
	  var _busNum = 0;
	  for (var i = 0, len = state.order.bus_bill.length; i < len; i++) {
	    _num += state.order.bus_bill[i].bus_num * state.order.bus_bill[i].seat_num;
	    _bag += state.order.bus_bill[i].bus_num * state.order.bus_bill[i].baggage_num;
	    _busNum += state.order.bus_bill[i].bus_num;
	  }
	  return {
	    seat: _num,
	    bag: _bag,
	    bus_num: _busNum
	  };
	};
	
	var bus_total_price = exports.bus_total_price = function bus_total_price(state) {
	  var _count = 0;
	  for (var i = 0, len = state.order.bus_bill.length; i < len; i++) {
	    var _item = state.order.bus_bill[i];
	    if (_item.price) {
	      var _bus_price = (0, _util.accMul)(_item.price, _item.bus_num);
	      _count = (0, _util.accAdd)(_count, _bus_price);
	    }
	  }
	  return _count;
	};
	
	var open_city_list = exports.open_city_list = function open_city_list(state) {
	  return state.order.open_city_list;
	};
	
	var open_city_list_format = exports.open_city_list_format = function open_city_list_format(state) {
	  return state.order.open_city_list_format;
	};
	
	var select_coupon = exports.select_coupon = function select_coupon(state) {
	  return {
	    money: state.myCoupon.select_money,
	    id: state.myCoupon.select_id
	  };
	};
	
	var invoice_info = exports.invoice_info = function invoice_info(state) {
	  return state.order.invoice_info;
	};
	
	var szhk_start_city = exports.szhk_start_city = function szhk_start_city(state) {
	  return state.location.hk_start ? '香港' : '广东';
	};
	
	var szhk_end_city = exports.szhk_end_city = function szhk_end_city(state) {
	  return state.location.hk_start ? '广东' : '香港';
	};
	
	var line_distance = exports.line_distance = function line_distance(state) {
	  return state.location.line_distance;
	};
	
	var include_hk = exports.include_hk = function include_hk(state) {
	  var _include = false;
	  if (state.order.type !== 'business') {
	    _include = true;
	  } else {
	    var _start_city = state.location.start_info ? state.location.start_info.split('-')[1] : '';
	    var _end_city = state.location.end_info ? state.location.end_info.split('-')[1] : '';
	    if (_start_city.indexOf('香港') === 0 || _end_city.indexOf('香港') === 0) {
	      _include = true;
	    }
	    if (!_include) {
	      for (var i = 0, len = state.location.way_address.length; i < len; i++) {
	        var _place = state.location.way_address[i];
	        if (_place.city && _place.city.indexOf('香港') === 0) {
	          _include = true;
	          break;
	        }
	      }
	    }
	  }
	  return _include;
	};
	
	var qiyu_group_id = exports.qiyu_group_id = function qiyu_group_id(state) {
	  return state.common.qiyu_group_id;
	};
	
	var qiyu_staff_id = exports.qiyu_staff_id = function qiyu_staff_id(state) {
	  return state.common.qiyu_staff_id;
	};
	
	var tips_add_site = exports.tips_add_site = function tips_add_site(state) {
	  return state.common.tips_add_site;
	};
	
	var enterprise_id = exports.enterprise_id = function enterprise_id(state) {
	  return state.common.enterprise_id;
	};
	
	var enterprise_server_phone = exports.enterprise_server_phone = function enterprise_server_phone(state) {
	  var phone = '';
	  var id = state.common.enterprise_id + '';
	  if (id === '199') {
	    phone = '13549267470';
	  } else if (id === '398') {
	    phone = '18955329596';
	  } else if (id === '498') {
	    phone = '02968916001';
	  }
	  return phone;
	};

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(86);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _mutationTypes = __webpack_require__(85);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  banner_list: [],
	  is_loading: false,
	  direction: 'forward',
	  back_path: null,
	  server_phone: '4008-520-084',
	  page_from: null,
	  is_weixin_browser: /micromessenger/.test(navigator.userAgent.toLowerCase()),
	  isiOS: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
	  is_android: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1,
	  is_used_listButton: window.localStorage.getItem('listButtonShow') === null ? 'firstUsed' : 'noFirst',
	  qiyu_group_id: '304059',
	  innerHeight: window.innerHeight,
	  qiyu_staff_id: '106250',
	  reload_page: false,
	  tips_add_site: window.localStorage.getItem('cache_tips_add_site') || '',
	  enterprise_id: ''
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_LOADING, function (state, is_loading) {
	  state.is_loading = is_loading;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_DIRECTION, function (state, direction) {
	  state.direction = direction;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_BACK_PATH, function (state, back_path) {
	  state.back_path = back_path;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.JUMP_LOGIN, function (state, self) {
	  self.$router.push('/login');
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_PAGE_FROM, function (state, path) {
	  state.page_from = path;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_IS_USED_LISTBUTTON, function (state, val) {
	  state.is_used_listButton = val;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_BANNER_LIST, function (state, data) {
	  state.banner_list = data;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_INNERHEIGHT, function (state, data) {
	  state.innerHeight = data;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_TIPS_ADD_SITE, function (state, val) {
	  state.tips_add_site = val;
	  window.localStorage.setItem('cache_tips_add_site', 'showed');
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_ENTERPRISE_ID, function (state, val) {
	  state.enterprise_id = val;
	
	  window.localStorage.setItem('cache_enterprise_id', val + '');
	}), _mutations);
	
	var actions = {
	  setLoading: function setLoading(_ref, val) {
	    var commit = _ref.commit;
	
	    commit('UPDATE_LOADING', val);
	  },
	  changeHeight: function changeHeight(_ref2, val) {
	    var commit = _ref2.commit;
	
	    commit('UPDATE_INNERHEIGHT', window.innerHeight);
	  },
	  setTipsAddSite: function setTipsAddSite(_ref3, val) {
	    var commit = _ref3.commit;
	
	    commit('UPDATE_TIPS_ADD_SITE', val);
	  },
	  setEnterprise: function setEnterprise(_ref4, val) {
	    var commit = _ref4.commit;
	
	    commit('UPDATE_ENTERPRISE_ID', val);
	  }
	};
	
	exports.default = {
	  namespaced: true,
	  actions: actions,
	  state: state,
	  mutations: mutations
	};

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(86);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _mutationTypes = __webpack_require__(85);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  os: null,
	  app_version: null,
	  model: null,
	  network: null,
	  os_version: null,
	  app_id: null
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, _mutationTypes.SET_APP_PARAMS, function (state, data) {
	  state.os = data.os;
	  state.app_version = data.app_version;
	  state.model = data.model;
	  state.network = data.network;
	  state.os_version = data.os_version;
	  state.app_id = data.app_id;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.SET_OS, function (state, os) {
	  state.os = os;
	}), _mutations);
	
	var actions = {
	  setAppParams: function setAppParams(_ref, data) {
	    var commit = _ref.commit;
	
	    commit('SET_APP_PARAMS', data);
	  },
	  setOS: function setOS(_ref2, os) {
	    var commit = _ref2.commit;
	
	    commit('SET_OS', os);
	  }
	};
	
	exports.default = {
	  namespaced: true,
	  actions: actions,
	  state: state,
	  mutations: mutations
	};

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(60);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _defineProperty2 = __webpack_require__(86);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _stringify = __webpack_require__(16);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _mutations;
	
	var _mutationTypes = __webpack_require__(85);
	
	var _BMap = __webpack_require__(113);
	
	var _BMap2 = _interopRequireDefault(_BMap);
	
	var _superagentJsonp = __webpack_require__(370);
	
	var _superagentJsonp2 = _interopRequireDefault(_superagentJsonp);
	
	var _superagent = __webpack_require__(64);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _order = __webpack_require__(168);
	
	var _order2 = _interopRequireDefault(_order);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  hk_start: window.localStorage.getItem('hk_start'),
	  history_address: window.localStorage.getItem('history_address') ? JSON.parse(window.localStorage.getItem('history_address')) : [],
	  start_info: window.localStorage.getItem('start_info'),
	  start_address: window.localStorage.getItem('start_address'),
	  end_info: window.localStorage.getItem('end_info'),
	  end_address: window.localStorage.getItem('end_address'),
	  way_info: window.localStorage.getItem('way_info'),
	  current_city: null,
	  select_open_city: window.localStorage.getItem('cache_select_open_city') || '',
	  line_distance: window.localStorage.getItem('cache_line_distance') ? JSON.parse(window.localStorage.getItem('cache_line_distance')) : {},
	  way_address: function () {
	    var data = JSON.parse(window.localStorage.getItem('way_address'));
	    var _arr = [];
	    if (data) {
	      for (var i = 0, len = data.length; i < len; i++) {
	        if (data[i].address) {
	          _arr.push(data[i]);
	        }
	      }
	    }
	    return _arr;
	  }(),
	
	  szhk_start_info: window.localStorage.getItem('szhk_start_info'),
	  szhk_end_info: window.localStorage.getItem('szhk_end_info'),
	  szhk_start_address: window.localStorage.getItem('szhk_start_address'),
	  szhk_end_address: window.localStorage.getItem('szhk_end_address'),
	  szhk_way_info: window.localStorage.getItem('szhk_way_info'),
	  szhk_way_address: function () {
	    var data = JSON.parse(window.localStorage.getItem('szhk_way_address'));
	    var _arr = [];
	    if (data) {
	      for (var i = 0, len = data.length; i < len; i++) {
	        if (data[i].address) {
	          _arr.push(data[i]);
	        }
	      }
	    }
	    return _arr;
	  }()
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_START_INFO, function (state, data) {
	  var _info = data;
	  if (data) {
	    _info = data.province + '-' + data.city + '-' + data.lng + '-' + data.lat;
	  }
	  state.start_info = _info;
	  window.localStorage.setItem('start_info', _info);
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_START_ADDRESS, function (state, address) {
	  state.start_address = address;
	  window.localStorage.setItem('start_address', address);
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_END_INFO, function (state, data) {
	  var _info = data;
	  if (data) {
	    _info = data.province + '-' + data.city + '-' + data.lng + '-' + data.lat;
	  }
	  state.end_info = _info;
	  window.localStorage.setItem('end_info', _info);
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_END_ADDRESS, function (state, address) {
	  state.end_address = address;
	  window.localStorage.setItem('end_address', address);
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_WAY_ADDRESS, function (state, data) {
	  if (data.type === 'add') {
	    state.way_address.push(data.data);
	  } else if (data.type === 'reduce') {
	    state.way_address.splice(data.index, 1);
	  } else if (data.index) {
	    state.way_address.splice(data.index, 1, data.data);
	  } else {
	    state.way_address = [];
	  }
	  window.localStorage.setItem('way_address', (0, _stringify2.default)(state.way_address));
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_WAY_INFO, function (state, info) {
	  state.way_info = info;
	  window.localStorage.setItem('way_info', info);
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_SZHK_START_INFO, function (state, data) {
	  var _info = data;
	  if (data) {
	    _info = data.province + '-' + data.city + '-' + data.lng + '-' + data.lat;
	  }
	  state.szhk_start_info = _info;
	  window.localStorage.setItem('szhk_start_info', _info);
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_SZHK_START_ADDRESS, function (state, address) {
	  address = address || '';
	  state.szhk_start_address = address;
	  window.localStorage.setItem('szhk_start_address', address);
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_SZHK_END_INFO, function (state, data) {
	  var _info = data;
	  if (data) {
	    _info = data.province + '-' + data.city + '-' + data.lng + '-' + data.lat;
	  }
	  state.szhk_end_info = _info;
	  window.localStorage.setItem('szhk_end_info', _info);
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_SZHK_END_ADDRESS, function (state, address) {
	  address = address || '';
	  state.szhk_end_address = address;
	  window.localStorage.setItem('szhk_end_address', address);
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_SZHK_WAY_ADDRESS, function (state, data) {
	  if (data.type === 'add') {
	    state.szhk_way_address.push(data.data);
	  } else if (data.type === 'reduce') {
	    state.szhk_way_address.splice(data.index, 1);
	  } else if (data.index) {
	    state.szhk_way_address.splice(data.index, 1, data.data);
	  } else {
	    state.szhk_way_address = [];
	  }
	  window.localStorage.setItem('szhk_way_address', (0, _stringify2.default)(state.szhk_way_address));
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_SZHK_WAY_INFO, function (state, info) {
	  state.szhk_way_info = info;
	  window.localStorage.setItem('szhk_way_info', info);
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_HISTORY_ADDRESS, function (state, data) {
	  for (var i = 0, len = state.history_address.length; i < len; i++) {
	    var _item = state.history_address[i];
	    if (_item.lng === data.lng && _item.lat === _item.lat) {
	      state.history_address.splice(i, 1);
	      break;
	    }
	  }
	  state.history_address.unshift(data);
	
	  if (state.history_address.length > 10) {
	    state.history_address.pop();
	  }
	  window.localStorage.setItem('history_address', (0, _stringify2.default)(state.history_address));
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_CURRENT_CITY, function (state, city) {
	  state.current_city = city;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_SELECT_OPEN_CITY, function (state, city) {
	  state.select_open_city = city;
	  window.localStorage.setItem('cache_select_open_city', city);
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_LINE_DISTANCE, function (state, params) {
	  if (params) {
	    state.line_distance = params;
	    window.localStorage.setItem('cache_line_distance', (0, _stringify2.default)(params));
	  }
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.UPDATE_HK_START, function (state, val) {
	  state.hk_start = val;
	  window.localStorage.setItem('hk_start', val);
	}), _mutations);
	
	var actions = {
	  switchAddress: function switchAddress(_ref) {
	    var commit = _ref.commit,
	        state = _ref.state;
	
	    var _szhk_start_address = JSON.parse((0, _stringify2.default)(state.szhk_start_address));
	    var _szhk_start_info = JSON.parse((0, _stringify2.default)(state.szhk_start_info));
	    var _szhk_end_address = JSON.parse((0, _stringify2.default)(state.szhk_end_address));
	    var _szhk_end_info = JSON.parse((0, _stringify2.default)(state.szhk_end_info));
	    var _params;
	    commit('UPDATE_SZHK_START_ADDRESS', _szhk_end_address);
	    if (_szhk_end_info) {
	      _params = _szhk_end_info.split('-');
	      commit('UPDATE_SZHK_START_INFO', {
	        province: _params[0],
	        city: _params[1],
	        lng: _params[2],
	        lat: _params[3]
	      });
	    }
	    commit('UPDATE_SZHK_END_ADDRESS', _szhk_start_address);
	    if (_szhk_start_info) {
	      _params = _szhk_start_info.split('-');
	      commit('UPDATE_SZHK_END_INFO', {
	        province: _params[0],
	        city: _params[1],
	        lng: _params[2],
	        lat: _params[3]
	      });
	    }
	    if (state.way_address && state.way_address.length > 0) {
	      state.way_address.reverse();
	      window.localStorage.setItem('way_address', (0, _stringify2.default)(state.way_address));
	    }
	    commit(_mutationTypes.UPDATE_HK_START, !state.hk_start);
	  },
	  searchAddress: function searchAddress(_ref2, params) {
	    var commit = _ref2.commit,
	        state = _ref2.state;
	
	    var _city = params.city ? params.city : state.select_open_city || state.current_city || '';
	    if (_city.indexOf('市') === -1 && _city.indexOf('香港') === -1 && _city.indexOf('澳门') === -1) {
	      _city = _city + '市';
	    }
	    if (params.keyword.length > 0) {
	      var _param = {
	        ak: 'b2tdmZtPCKfwW8iwn5svaT03',
	        region: _city,
	        output: 'json',
	
	        query: params.keyword
	      };
	      return new _promise2.default(function (resolve, reject) {
	        _superagent2.default.get('https://api.map.baidu.com/place/v2/suggestion').query(_param).set('Accept', 'application/json').use(_superagentJsonp2.default).end(function (err, res) {
	          if (err) {} else {
	            var _arr = [];
	            for (var i = 0, len = res.body.result.length; i < len; i++) {
	              var _place = res.body.result[i];
	              if (_place.location) {
	                _arr.push({
	                  address_title: _place.name,
	                  point: _place.location
	                });
	              }
	            }
	            resolve(_arr);
	          }
	        });
	      });
	    }
	  },
	  geocoder: function geocoder(_ref3, arr) {
	    var commit = _ref3.commit,
	        state = _ref3.state;
	
	    var _promise_arr = [];
	    for (var i = 0, len = arr.length; i < len; i++) {
	      var _p = new _promise2.default(function (resolve, reject) {
	        _superagent2.default.get('https://api.map.baidu.com/geocoder/v2/').query({
	          output: 'json',
	          ak: 'b2tdmZtPCKfwW8iwn5svaT03',
	          location: arr[i].point.lat + ',' + arr[i].point.lng
	        }).set('Accept', 'application/json').use(_superagentJsonp2.default).end(function (err, res) {
	          if (err) {} else {
	            resolve(res);
	          }
	        });
	      });
	      _promise_arr.push(_p);
	    }
	    return _promise2.default.all(_promise_arr);
	  },
	  getTwoPlaceDistance: function getTwoPlaceDistance(_ref4, type) {
	    var commit = _ref4.commit,
	        state = _ref4.state;
	
	    if (_order2.default.state.type !== 'business') {
	      _start = state.szhk_start_info.split('-')[3] + ',' + state.szhk_start_info.split('-')[2];
	      _end = state.szhk_end_info.split('-')[3] + ',' + state.szhk_end_info.split('-')[2];
	    } else {
	      var _start = state.start_info.split('-')[3] + ',' + state.start_info.split('-')[2];
	      var _end = state.end_info.split('-')[3] + ',' + state.end_info.split('-')[2];
	    }
	    var _param = {
	      ak: 'b2tdmZtPCKfwW8iwn5svaT03',
	      origins: _start,
	      destinations: _end,
	      output: 'json'
	    };
	    if (type === 'wayPoints') {
	      _param.origin = _start;
	      _param.destination = _end;
	      _param.waypoints = '';
	      if (_order2.default.state.type !== 'business') {
	        if (state.szhk_way_address && state.szhk_way_address.length > 0) {
	          _param.waypoints = state.szhk_way_address.map(function (val, index) {
	            if (val.lat) {
	              return val.lat + ',' + val.lng;
	            } else {
	              return '';
	            }
	          }).join('|');
	        }
	      } else {
	        if (state.way_address && state.way_address.length > 0) {
	          _param.waypoints = state.way_address.map(function (val, index) {
	            if (val.lat) {
	              return val.lat + ',' + val.lng;
	            } else {
	              return '';
	            }
	          }).join('|');
	        }
	      }
	      return new _promise2.default(function (resolve, reject) {
	        _superagent2.default.get('https://api.map.baidu.com/direction/v2/driving').query(_param).set('Accept', 'application/json').use(_superagentJsonp2.default).end(function (err, res) {
	          var _cache = {};
	          var _result = {};
	          if (err) {
	            console.log(err);
	          } else {
	            _result.status = res.body.status;
	            if (res.body.status === 0) {
	              if (res.body.result && res.body.result.routes && res.body.result.routes.length > 0) {
	                _cache = res.body.result.routes[0];
	                _result.result = {
	                  distance: {
	                    text: parseFloat(_cache.distance / 1000).toFixed(2) + '公里',
	                    value: _cache.distance
	                  },
	                  duration: {
	                    text: parseFloat(_cache.duration / 60) > 60 ? parseFloat(_cache.duration / 3600).toFixed(2) + '小时' : parseFloat(_cache.duration / 60).toFixed(2) + '分钟',
	                    value: _cache.duration
	                  }
	                };
	                commit(_mutationTypes.UPDATE_LINE_DISTANCE, _result.result);
	              }
	            }
	            resolve(_result);
	          }
	        });
	      });
	    } else {
	      return new _promise2.default(function (resolve, reject) {
	        _superagent2.default.get('https://api.map.baidu.com/routematrix/v2/driving').query(_param).set('Accept', 'application/json').use(_superagentJsonp2.default).end(function (err, res) {
	          var _result = {};
	          if (err) {
	            console.log(err);
	          } else {
	            _result.status = res.body.status;
	
	            if (res.body.result && res.body.result.length > 0) {
	              _result.result = res.body.result[0];
	              commit(_mutationTypes.UPDATE_LINE_DISTANCE, _result.result);
	            }
	            resolve(_result);
	          }
	        });
	      });
	    }
	  },
	  setOrderLocation: function setOrderLocation(_ref5, data) {
	    var commit = _ref5.commit,
	        state = _ref5.state;
	
	    if (data.type === 'way') {
	      var _data = {
	        address: data.address_title,
	        lng: data.lng,
	        lat: data.lat,
	        city: data.city,
	        province: data.province,
	        address_detail: data.address
	      };
	      commit(_order2.default.state.type === 'business' ? 'UPDATE_WAY_ADDRESS' : 'UPDATE_SZHK_WAY_ADDRESS', {
	        type: 'update',
	        index: data.index,
	        data: _data
	      });
	    } else {
	      var infoType = _order2.default.state.type === 'business' ? _mutationTypes.UPDATE_START_INFO : _mutationTypes.UPDATE_SZHK_START_INFO;
	      var addressType = _order2.default.state.type === 'business' ? _mutationTypes.UPDATE_START_ADDRESS : _mutationTypes.UPDATE_SZHK_START_ADDRESS;
	      if (data.type === 'end') {
	        infoType = _order2.default.state.type === 'business' ? _mutationTypes.UPDATE_END_INFO : _mutationTypes.UPDATE_SZHK_END_INFO;
	        addressType = _order2.default.state.type === 'business' ? _mutationTypes.UPDATE_END_ADDRESS : _mutationTypes.UPDATE_SZHK_END_ADDRESS;
	      }
	      commit(infoType, data);
	      commit(addressType, data.address_title);
	    }
	    commit(_mutationTypes.UPDATE_HISTORY_ADDRESS, data);
	  },
	  updateWayAddress: function updateWayAddress(_ref6, data) {
	    var commit = _ref6.commit,
	        state = _ref6.state;
	
	    var _len = _order2.default.state.type === 'business' ? state.way_address.length : state.szhk_way_address.length;
	    if (data.type !== 'add' || _len !== 3) {
	      commit(_order2.default.state.type === 'business' ? 'UPDATE_WAY_ADDRESS' : 'UPDATE_SZHK_WAY_ADDRESS', data);
	    }
	  },
	  initCurrentPos: function initCurrentPos(_ref7) {
	    var commit = _ref7.commit,
	        state = _ref7.state;
	
	    if (!state.current_position) {
	      var geolocation = new _BMap2.default.Geolocation();
	      geolocation.getCurrentPosition(function (result) {
	        if (this.getStatus() === window.BMAP_STATUS_SUCCESS) {
	          commit(_mutationTypes.UPDATE_CURRENT_CITY, result.address.city);
	        }
	      });
	    }
	  },
	  selectOpenCity: function selectOpenCity(_ref8, city) {
	    var commit = _ref8.commit,
	        state = _ref8.state;
	
	    commit(_mutationTypes.UPDATE_SELECT_OPEN_CITY, city);
	  }
	};
	
	exports.default = {
	  actions: actions,
	  state: state,
	  mutations: mutations
	};

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(60);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _defineProperty2 = __webpack_require__(86);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutationTypes = __webpack_require__(85);
	
	var _superagent = __webpack_require__(64);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _userInfo = __webpack_require__(169);
	
	var _userInfo2 = _interopRequireDefault(_userInfo);
	
	var _actions = __webpack_require__(84);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  select_id: null,
	  select_money: null
	};
	
	var mutations = (0, _defineProperty3.default)({}, _mutationTypes.UPDATE_SELECT_COUPON, function (state, data) {
	  state.select_id = data.vouchers_Identifier;
	  state.select_money = data.vouchers_money;
	});
	
	var actions = {
	  userCoupon: function userCoupon(_ref, type) {
	    var commit = _ref.commit,
	        rootState = _ref.rootState;
	
	    var _params = {
	      type: type,
	      user_id: _userInfo2.default.state.user_id,
	      vouchers_type: 8,
	      os: '0'
	    };
	    return new _promise2.default(function (resolve, reject) {
	      _params = (0, _actions.RequestControl)(rootState, _params);
	      commit('UPDATE_LOADING', true);
	      _superagent2.default.post('/index.php/users/vouchers/get_my_vouchers').send(_params).type('form').end(function (err, res) {
	        commit('UPDATE_LOADING', false);
	        if (err) throw err;
	        var _res = JSON.parse(res.text);
	        if (_res.result === '0000') {
	          resolve(_res);
	        } else {
	          (0, _actions.RequestCommonResponse)(rootState, _res, reject);
	        }
	      });
	    });
	  },
	  userHistoryCoupon: function userHistoryCoupon(_ref2, params) {
	    var commit = _ref2.commit,
	        rootState = _ref2.rootState;
	
	    return new _promise2.default(function (resolve, reject) {
	      commit('UPDATE_LOADING', true);
	      params = (0, _actions.RequestControl)(rootState, params);
	      _superagent2.default.post('/index.php/users/vouchers/get_my_vouchers').send(params).type('form').end(function (err, res) {
	        commit('UPDATE_LOADING', false);
	        if (err) throw err;
	        var _res = JSON.parse(res.text);
	        if (_res.result === '0000') {
	          resolve(_res);
	        } else {
	          (0, _actions.RequestCommonResponse)(rootState, _res, reject);
	        }
	      });
	    });
	  },
	  resetVoucher: function resetVoucher(_ref3, orderId) {
	    var commit = _ref3.commit,
	        rootState = _ref3.rootState;
	
	    var _params = {
	      user_id: rootState.userInfo.user_id,
	      order_id: orderId
	    };
	    return new _promise2.default(function (resolve, reject) {
	      _params = (0, _actions.RequestControl)(rootState, _params);
	      _superagent2.default.post('/index.php/charter/mine/reset_voucher').send(_params).type('form').end(function (err, res) {
	        commit('UPDATE_LOADING', false);
	        if (err) throw err;
	        var _res = JSON.parse(res.text);
	        if (_res.result === '0000') {
	          resolve(_res);
	        } else {
	          (0, _actions.RequestCommonResponse)(rootState, _res, reject);
	        }
	      });
	    });
	  },
	  clearSelectCoupon: function clearSelectCoupon(_ref4, params) {
	    var commit = _ref4.commit;
	
	    commit('UPDATE_SELECT_COUPON', {
	      vouchers_Identifier: null,
	      vouchers_money: null
	    });
	  },
	  setSelectCoupon: function setSelectCoupon(_ref5, params) {
	    var commit = _ref5.commit;
	
	    commit('UPDATE_SELECT_COUPON', params);
	  }
	};
	
	exports.default = {
	  actions: actions,
	  mutations: mutations,
	  state: state
	};

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(60);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _superagent = __webpack_require__(64);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _actions = __webpack_require__(84);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actions = {
	  userOrder: function userOrder(_ref, params) {
	    var commit = _ref.commit,
	        rootState = _ref.rootState;
	
	    return new _promise2.default(function (resolve, reject) {
	      commit('UPDATE_LOADING', true);
	      params = (0, _actions.RequestControl)(rootState, params);
	      _superagent2.default.post('/index.php/order/mine/get_orders_new').send(params).type('form').end(function (err, res) {
	        if (err) throw err;
	        var _res = JSON.parse(res.text);
	        if (_res.result === '0000') {
	          setTimeout(function () {
	            commit('UPDATE_LOADING', false);
	          }, 200);
	          resolve(_res);
	        } else {
	          (0, _actions.RequestCommonResponse)(rootState, _res, reject);
	        }
	      });
	    });
	  },
	  getOrderBusLocation: function getOrderBusLocation(_ref2, params) {
	    var commit = _ref2.commit,
	        rootState = _ref2.rootState;
	
	    return new _promise2.default(function (resolve, reject) {
	      params = (0, _actions.RequestControl)(rootState, params);
	      _superagent2.default.post('/index.php/charter/order/bus_locations').send(params).type('form').end(function (err, res) {
	        if (err) throw err;
	        var _res = JSON.parse(res.text);
	        if (_res.result === '0000') {
	          resolve(_res);
	        } else {
	          (0, _actions.RequestCommonResponse)(rootState, _res, reject);
	        }
	      });
	    });
	  }
	};
	
	exports.default = {
	  actions: actions
	};

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(60);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _superagent = __webpack_require__(64);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _actions = __webpack_require__(84);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actions = {
	  getOrderDetails: function getOrderDetails(_ref, params) {
	    var commit = _ref.commit,
	        rootState = _ref.rootState;
	
	    return new _promise2.default(function (resolve, reject) {
	      params = (0, _actions.RequestControl)(rootState, params);
	      _superagent2.default.post('/index.php/order/mine/get_charter_details').send(params).type('form').end(function (err, res) {
	        if (err) throw err;
	        var _res = JSON.parse(res.text);
	        if (_res.result === '0000') {
	          resolve(_res);
	        } else {
	          (0, _actions.RequestCommonResponse)(rootState, _res, reject);
	        }
	      });
	    });
	  }
	};
	
	exports.default = {
	  actions: actions
	};

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(60);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _superagent = __webpack_require__(64);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	var _actions = __webpack_require__(84);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actions = {
	  userEvaluate: function userEvaluate(_ref, params) {
	    var commit = _ref.commit,
	        rootState = _ref.rootState;
	
	    return new _promise2.default(function (resolve, reject) {
	      params = (0, _actions.RequestControl)(rootState, params);
	      _superagent2.default.post('/index.php/charter/mine/get_level_evaluate').send(params).type('form').end(function (err, res) {
	        if (err) throw err;
	        var _res = JSON.parse(res.text);
	        if (_res.result === '0000') {
	          resolve(_res);
	        } else {
	          (0, _actions.RequestCommonResponse)(rootState, _res, reject);
	        }
	      });
	    });
	  },
	  submitEvaluate: function submitEvaluate(_ref2, params) {
	    var commit = _ref2.commit,
	        rootState = _ref2.rootState;
	
	    return new _promise2.default(function (resolve, reject) {
	      params = (0, _actions.RequestControl)(rootState, params);
	      _superagent2.default.post('/index.php/charter/mine/submit_order_evaluate').send(params).type('form').end(function (err, res) {
	        if (err) throw err;
	        var _res = JSON.parse(res.text);
	        if (_res.result === '0000') {
	          resolve(_res);
	        } else {
	          (0, _actions.RequestCommonResponse)(rootState, _res, reject);
	        }
	      });
	    });
	  },
	  userSelfEvaluate: function userSelfEvaluate(_ref3, params) {
	    var commit = _ref3.commit,
	        rootState = _ref3.rootState;
	
	    return new _promise2.default(function (resolve, reject) {
	      params = (0, _actions.RequestControl)(rootState, params);
	      _superagent2.default.post('/index.php/charter/mine/get_order_evaluate').send(params).type('form').end(function (err, res) {
	        if (err) throw err;
	        var _res = JSON.parse(res.text);
	        if (_res.result === '0000') {
	          resolve(_res);
	        } else {
	          (0, _actions.RequestCommonResponse)(rootState, _res, reject);
	        }
	      });
	    });
	  }
	};
	
	exports.default = {
	  actions: actions
	};

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _index = __webpack_require__(167);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _vuex = __webpack_require__(3);
	
	var _util = __webpack_require__(7);
	
	var _util2 = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {},
	  store: _index2.default,
	  data: function data() {
	    return {
	      first_init: true,
	      init_wx: false,
	      init_dudu_app: false,
	      routerTransition: {
	        forward: 'slideRL',
	        back: 'slideLR'
	      },
	      direction: 'forward'
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    os: 'os',
	    qiyu_group_id: 'qiyu_group_id',
	    is_app: 'is_app',
	    reload_page: 'reload_page',
	    handleTokenError: 'handleTokenError'
	  }), {
	    title: function title() {
	      return this.$route.meta ? this.$route.meta.title : '';
	    },
	    is_loading: function is_loading() {
	      return this.$store.state.common.is_loading;
	    }
	  }),
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['clearOrder', 'initQiYuScript', 'changeHeight'])),
	  watch: {
	    reload_page: function reload_page() {
	      var _self = this;
	      (0, _util2.showTips)('登录失效，请重新登录');
	      setTimeout(function () {
	        if (_self.handleTokenError) {
	          if (_self.os === '1') {
	            (0, _util.setupWebViewJavascriptBridge)(function (bridge) {
	              bridge.callHandler('requestAppLogin', {
	                data: '0005',
	                info: '登录失效，请重新登录'
	              });
	              bridge.registerHandler('appLoginResult', function (data) {
	                _self.setUserInfo(data);
	                _self.$router.go(0);
	              });
	            });
	          } else if (_self.os === '2') {
	            try {
	              window.app.appLoginResult = function (data) {
	                _self.setUserInfo(data);
	                _self.$router.go(0);
	              };
	              window.app.requestAppLoginExit();
	            } catch (e) {
	              console.warn('== 出现错误, 如果在非android环境下访问, 出现该警告是正常的.');
	            }
	          }
	        } else {
	          window.location.reload();
	        }
	      }, 1000);
	    }
	  },
	  created: function created() {
	    window.addEventListener('resize', this.changeHeight);
	
	    var _self = this;
	    if (_self.os === '1') {
	      (0, _util.setupWebViewJavascriptBridge)(function (bridge) {
	        bridge.registerHandler('continueCharter', function (data, responseCallback) {
	          _self.clearOrder();
	          window.history.go(-1);
	        });
	      });
	    }
	
	    window.setTimeout(function () {
	      _self.initQiYuScript();
	    }, 1000);
	  },
	  updated: function updated() {
	    setTimeout(function () {
	      window.document.body.scrollTop = 0;
	      window.document.documentElement.scrollTop = 0;
	    }, 500);
	  }
	};

/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _util = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'enterprise',
	  props: {
	    title: {},
	    transition: {}
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['enterprise_id']), {
	    keep_alive: function keep_alive() {
	      return this.$route.meta.keep_alive;
	    }
	  }),
	  methods: {},
	  created: function created() {
	    var _self = this;
	    var _id = _self.enterprise_id + '';
	    var str = '';
	    if (_id === '199') {
	      str = '小欧出行';
	    } else if (_id === '398') {
	      str = '奇瑞包车';
	    } else if (_id === '498') {
	      str = '美光半导体智能用车';
	    }
	    if (str) {
	      (0, _util.setDocumentTitle)(str);
	    }
	  }
	};

/***/ }),

/***/ 326:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 327:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 328:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 329:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 330:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 346:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 356:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 363:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 364:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 382:
/***/ (function(module, exports) {

	module.exports = "data:image/gif;base64,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"

/***/ }),

/***/ 386:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(356)
	
	/* script */
	__vue_exports__ = __webpack_require__(219)
	
	/* template */
	var __vue_template__ = __webpack_require__(425)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 396:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(346)
	
	/* script */
	__vue_exports__ = __webpack_require__(242)
	
	/* template */
	var __vue_template__ = __webpack_require__(415)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4c6c0230"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 415:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _h('div', [_h('keep-alive', [(_vm.keep_alive) ? _h('router-view', {
	    attrs: {
	      "title": _vm.title
	    }
	  }) : _vm._e()]), " ", (!_vm.keep_alive) ? _h('router-view', {
	    attrs: {
	      "title": _vm.title
	    }
	  }) : _vm._e()])
	},staticRenderFns: []}

/***/ }),

/***/ 425:
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _h('div', [_h('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.is_loading),
	      expression: "is_loading"
	    }],
	    staticClass: "globalLoading"
	  }, [_vm._m(0)]), " ", _h('router-view', {
	    class: _vm.is_app ? 'inApp' : '',
	    attrs: {
	      "title": _vm.title,
	      "transition": 'page-pop-' + (_vm.direction === 'forward' ? 'in' : 'out')
	    },
	    slot: "main"
	  })])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _h('span', [_h('img', {
	    attrs: {
	      "src": __webpack_require__(382)
	    }
	  })])
	}]}

/***/ }),

/***/ 435:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.b82267a7ff0cac2d9a60.js